import { defineMessages } from 'react-intl';


const messages = defineMessages({
    login: {
        id: 'app.login',
        defaultMessage: 'Login',
        description: 'Login Nav link',
    },
    contact: {
        id: 'app.contact',
        defaultMessage: 'Contact',
        description: 'Contact Nav link',
    },
    logo: {
        id: 'app.logo',
        defaultMessage: 'Logo',
        description: 'Logo'
    },
    ogImageLabel: {
        id: 'app.ogImageLabel',
        defaultMessage: 'OG Image',
        description: 'OG Image'
    },
    ogImageTooltip: {
        id: 'app.ogImageTooltip',
        defaultMessage: 'It\'s the image that represents your webpage when shared on platforms like Facebook, X, or LinkedIn.(Recommended size: at least 1,200 x 630 pixels with a file size under 8MB)',
        description: 'Tooltip'
    },
    siteSettings: {
        id: 'app.siteSettings',
        defaultMessage: 'Site Settings',
        description: 'Site Settings'
    },
    HomeSiteSettings: {
        id: 'app.HomeSiteSettings',
        defaultMessage: 'Homepage Settings',
        description: 'HomeSiteSettings'
    },
    messageRequired: {
        id: 'app.messageRequired',
        defaultMessage: 'Message is required',
        description: 'Message is required'
    },
    metaTitle: {
        id: 'app.metaTitle',
        defaultMessage: 'Meta Title',
        description: 'Meta Title'
    },
    metaDescriptionText: {
        id: 'app.metaDescriptionText',
        defaultMessage: 'Meta Description',
        description: 'Meta Description'
    },
    metaDescription: {
        id: 'app.metaDescription',
        defaultMessage: 'Description must be 255 characters or less',
        description: 'Description must be 255 characters or less'
    },
    pageTitle: {
        id: 'app.pageTitle',
        defaultMessage: 'Page Title',
        description: 'Page Title'
    },
    pageUrl: {
        id: 'app.pageUrl',
        defaultMessage: 'Page URL',
        description: 'Page URL'
    },
    invalidUrl: {
        id: 'app.invalidUrl',
        defaultMessage: 'Invalid Page URL',
        description: 'Invalid Page URL'
    },
    ratings: {
        id: 'app.ratings',
        defaultMessage: 'View Job Ratings',
        description: 'Ratings'
    },
    reasonRequired: {
        id: 'app.reasonRequired',
        defaultMessage: 'Reason is required',
        description: 'Reason is required'
    },
    exceedLimit: {
        id: 'app.exceedLimit',
        defaultMessage: 'Exceeding character limit',
        description: 'Exceeding character limit'
    },
    cancelReason: {
        id: 'app.cancelReason',
        defaultMessage: 'Cancel Reason',
        description: 'Cancel Reason'
    },
    cancelledBy: {
        id: 'app.cancelledBy',
        defaultMessage: 'Cancelled By',
        description: 'Cancelled By'
    },
    changePassword: {
        id: 'app.changePassword',
        defaultMessage: 'Change Password',
        description: 'Change Password'
    },
    addCancelReason: {
        id: 'app.addCancelReason',
        defaultMessage: 'Add Cancel Reason',
        description: 'Add Cancel Reason'
    },
    editCancelReason: {
        id: 'app.editCancelReason',
        defaultMessage: 'Edit Cancel Reason',
        description: 'Edit Cancel Reason'
    },
    reason: {
        id: 'app.reason',
        defaultMessage: 'Reason',
        description: 'Reason'
    },
    manageNotifications: {
        id: 'app.manageNotifications',
        defaultMessage: 'Send Notifications',
        description: 'Manage Notifications'
    },
    adminpanel: {
        id: 'app.adminpanel',
        defaultMessage: 'Admin Panel',
        description: 'admin panel',
    },
    dashboard: {
        id: 'app.dashboard',
        defaultMessage: 'Dashboard',
        description: 'dashboard',
    },
    settings: {
        id: 'app.settings',
        defaultMessage: 'Settings',
        description: 'settings',
    },
    users: {
        id: 'app.users',
        defaultMessage: 'Users',
        description: 'users',
    },
    formssidebar: {
        id: 'app.formssidebar',
        defaultMessage: 'Forms',
        description: 'formssidebar',
    },
    email: {
        id: 'app.emailaddress',
        defaultMessage: 'Email Address',
        description: 'emailaddress',
    },
    emailaddress: {
        id: 'app.emailaddress',
        defaultMessage: 'Email Address',
        description: 'emailaddress',
    },
    password: {
        id: 'app.password',
        defaultMessage: 'Password',
        description: 'password',
    },
    select: {
        id: 'app.select',
        defaultMessage: 'Select',
        description: 'select',
    },
    textarea: {
        id: 'app.textarea',
        defaultMessage: 'Text Area',
        description: 'textarea',
    },
    firstName: {
        id: 'app.firstName',
        defaultMessage: 'First Name',
        description: 'firstName',
    },
    lastName: {
        id: 'app.lastName',
        defaultMessage: 'Last Name',
        description: 'lastName',
    },
    phoneNumber: {
        id: 'app.phoneNumber',
        defaultMessage: 'Phone Number',
        description: 'phoneNumber',
    },
    profilePicture: {
        id: 'app.profilePicture',
        defaultMessage: 'Profile Picture',
        description: 'profilePicture',
    },
    required: {
        id: 'app.required',
        defaultMessage: '*Required',
        description: 'required error message',
    },
    emailRequired: {
        id: 'app.emailRequired',
        defaultMessage: 'Email is required',
        description: 'Email is required',
    },
    emailInvalid: {
        id: 'app.emailInValid',
        defaultMessage: 'Invalid Email Address',
        description: 'Invalid Email Address',
    },
    passwordRequired: {
        id: 'app.passwordRequired',
        defaultMessage: 'Password is required',
        description: 'Password is required',
    },
    passwordInvalid: {
        id: 'app.passwordInValid',
        defaultMessage: 'Your password must be at least 8 characters. Please try again',
        description: 'Invalid Password',
    },
    submitButton: {
        id: 'app.submitButton',
        defaultMessage: 'Submit',
        description: 'Submit',
    },
    cancelButton: {
        id: 'app.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Cancel',
    },
    table: {
        id: 'app.table',
        defaultMessage: 'Table',
        description: 'Table',
    },
    form: {
        id: 'app.form',
        defaultMessage: 'Form',
        description: 'form',
    },
    siteAdmin: {
        id: 'app.siteAdmin',
        defaultMessage: 'Site Admin',
        description: 'siteAdmin',
    },
    usersMenu: {
        id: 'app.usersMenu',
        defaultMessage: 'Manage Users',
        description: 'usersMenu',
    },
    partnerMenu: {
        id: 'app.partnerMenu',
        defaultMessage: 'Manage Service Providers',
        description: 'partnerMenu',
    },
    categoryMenu: {
        id: 'app.categoryMenu',
        defaultMessage: 'Manage Categories',
        description: 'categoryMenu',
    },
    categorieslist: {
        id: 'app.categorieslist',
        defaultMessage: 'Categories',
        description: 'categoryMenu',
    },
    bookingsMenu: {
        id: 'app.bookingsMenu',
        defaultMessage: 'Manage Jobs',
        description: 'bookingsMenu',
    },
    categoryTitle: {
        id: 'app.categoryTitle',
        defaultMessage: 'Category Title',
        description: 'Category Title',
    },
    country: {
        id: 'app.country',
        defaultMessage: 'Country',
        description: 'Country Name'
    },
    createdAt: {
        id: 'app.createdAt',
        defaultMessage: 'Account Created on',
        description: 'Created date'
    },
    action: {
        id: 'app.action',
        defaultMessage: 'Action',
        description: 'Action'
    },
    basePrice: {
        id: 'app.basePrice',
        defaultMessage: 'Base Price',
        description: 'base price amount'
    },
    status: {
        id: 'app.status',
        defaultMessage: 'Status',
        description: 'Status Active/Inactive'
    },
    editAction: {
        id: 'app.editAction',
        defaultMessage: 'Edit',
        description: 'Edit action name'
    },
    deleteAction: {
        id: 'app.deleteAction',
        defaultMessage: 'Delete',
        description: 'Delete action name'
    },
    totalFare: {
        id: 'app.totalFare',
        defaultMessage: 'Total Fare',
        description: 'Total Fare'
    },
    promoCodeId: {
        id: 'app.promoCodeId',
        defaultMessage: 'Promo Code',
        description: 'Promo Code'
    },
    platformDiscount: {
        id: 'app.platformDiscount',
        defaultMessage: 'Platform offered discount',
        description: 'Special platformDiscount'
    },
    userDiscount: {
        id: 'app.userDiscount',
        defaultMessage: 'Coupon Discount',
        description: 'discount text'
    },
    userPayableAmount: {
        id: 'app.userPayableAmount',
        defaultMessage: 'User Payable Amount',
        description: 'userPayableAmount'
    },
    bookingStatus: {
        id: 'app.bookingStatus',
        defaultMessage: 'Job Status',
        description: 'Job Status'
    },
    userName: {
        id: 'app.userName',
        defaultMessage: 'User Name',
        description: 'User Name'
    },
    partnerName: {
        id: 'app.partnerName',
        defaultMessage: 'Service Provider Name',
        description: 'Service Provider Name'
    },
    userEmail: {
        id: 'app.userEmail',
        defaultMessage: 'User Email',
        description: 'User Email'
    },
    partnerEmail: {
        id: 'app.partnerEmail',
        defaultMessage: 'Service Provider Email',
        description: 'Service Provider Email'
    },
    bookingId: {
        id: 'app.bookingId',
        defaultMessage: 'Booking ID',
        description: 'Booking ID'
    },
    category: {
        id: 'app.category',
        defaultMessage: 'Category',
        description: 'Category'
    },
    view: {
        id: 'app.view',
        defaultMessage: 'View',
        description: 'View Details Link'
    },
    details: {
        id: 'app.details',
        defaultMessage: 'Details',
        description: 'Details'
    },
    userServiceFee: {
        id: 'app.userServiceFee',
        defaultMessage: 'User Service Fee',
        description: 'User Service Fee'
    },
    partnerServiceFee: {
        id: 'app.partnerServiceFee',
        defaultMessage: 'Service Provider Service Fee',
        description: 'Service Provider Service Fee'
    },
    categoryName: {
        id: 'app.categoryName',
        defaultMessage: 'Category Name',
        description: 'Category Name'
    },
    categoryLogo: {
        id: 'app.categoryLogo',
        defaultMessage: 'Logo',
        description: 'Category Logo'
    },
    categoryBanner: {
        id: 'app.categoryBanner',
        defaultMessage: 'Banner',
        description: 'Category Banner'
    },
    isPopular: {
        id: 'app.isPopular',
        defaultMessage: 'Is-Popular',
        description: 'Is-Popular'
    },
    isJobPhotoRequired: {
        id: 'app.isJobPhotoRequired',
        defaultMessage: 'Allow users to upload photos for the job',
        description: 'isJobPhotoRequired'
    },
    pricingType: {
        id: 'app.pricingType',
        defaultMessage: 'Pricing Type',
        description: 'Pricing Type'
    },
    update: {
        id: 'app.update',
        defaultMessage: 'Update',
        description: 'Update'
    },
    userStatus: {
        id: 'app.userStatus',
        defaultMessage: 'User Status',
        description: 'User Status Active/Inactive'
    },
    active: {
        id: 'app.active',
        defaultMessage: 'Active',
        description: 'Active Status'
    },
    inactive: {
        id: 'app.inactive',
        defaultMessage: 'Inactive',
        description: 'Inactive Status'
    },
    pending: {
        id: 'app.pending',
        defaultMessage: 'Pending',
        description: 'Pending Status'
    },
    banStatus: {
        id: 'app.banStatus',
        defaultMessage: 'Ban Status',
        description: 'Ban Status Permit/Ban'
    },
    permit: {
        id: 'app.permit',
        defaultMessage: 'Permit',
        description: 'Permit Status'
    },
    ban: {
        id: 'app.ban',
        defaultMessage: 'Ban',
        description: 'Ban Status'
    },
    phoneDialCode: {
        id: 'app.phoneDialCode',
        defaultMessage: 'Country Code',
        description: 'Phone Dial Code'
    },
    addCategory: {
        id: 'app.addCategory',
        defaultMessage: 'Add Category',
        description: 'Add category form header'
    },
    editUser: {
        id: 'app.editUser',
        defaultMessage: 'Edit User',
        description: 'Edit User form header'
    },
    editPartner: {
        id: 'app.editPartner',
        defaultMessage: 'Edit Service Provider',
        description: 'Edit Service Provider form header'
    },
    editCategory: {
        id: 'app.editCategory',
        defaultMessage: 'Edit Category',
        description: 'Edit category form header'
    },
    goBack: {
        id: 'app.goBack',
        defaultMessage: 'Go back',
        description: 'Go Back Button Text'
    },
    floatError: {
        id: 'app.floatError',
        defaultMessage: 'It should be a number value',
        description: 'Numeric Error Response'
    },
    numericValue: {
        id: 'app.numericValue',
        defaultMessage: 'Numeric value required',
        description: 'Numeric value required'
    },
    validUrl: {
        id: 'app.validUrl',
        defaultMessage: 'Valid URL required',
        description: 'Valid URL required'
    },
    phoneError: {
        id: 'app.numberError',
        defaultMessage: 'Invalid Phone Number',
        description: 'Invalid Phone Number'
    },
    currency: {
        id: 'app.currency',
        defaultMessage: 'Currency',
        description: 'Currency Type'
    },
    manageDashboard: {
        id: 'app.manageDashboard',
        defaultMessage: 'Dashboard',
        description: 'Manage Dashboard'
    },
    chooseFile: {
        id: 'app.chooseFile',
        defaultMessage: 'Choose File',
        description: ''
    },
    maximumUploadSizeLabel: {
        id: 'app.maximumUploadSizeLabel',
        defaultMessage: 'Maximum upload size',
        description: ''
    },
    followUs: {
        id: 'app.followUs',
        defaultMessage: 'Follow  Us',
        description: 'Follow Us',
    },
    user: {
        id: 'app.user',
        defaultMessage: 'User',
        description: 'user',
    },
    partner: {
        id: 'app.partner',
        defaultMessage: 'Service Provider',
        description: 'partner',
    },
    partners: {
        id: 'app.partners',
        defaultMessage: 'Service Providers',
        description: 'partner',
    },
    today: {
        id: 'app.today',
        defaultMessage: 'Today',
        description: 'today',
    },
    weekly: {
        id: 'app.weekly',
        defaultMessage: 'This Week',
        description: 'weekly',
    },
    montly: {
        id: 'app.montly',
        defaultMessage: 'This Month',
        description: 'montly',
    },
    bookings: {
        id: 'app.bookings',
        defaultMessage: 'Bookings',
        description: 'bookings',
    },
    logout: {
        id: 'app.logout',
        defaultMessage: 'Log out',
        description: 'logout option',
    },
    goToMainSite: {
        id: 'app.goToMainSite',
        defaultMessage: 'Go to main site',
        description: 'goToMainSite option',
    },
    managePromoCode: {
        id: 'app.managePromoCode',
        defaultMessage: 'Manage Promocode',
        description: 'managePromoCode sidemenu',
    },
    addPromoCode: {
        id: 'app.addPromoCode',
        defaultMessage: 'Add Promo Code',
        description: 'Add PromoCode',
    },
    editPromoCode: {
        id: 'app.editPromoCode',
        defaultMessage: 'Edit Promo Code',
        description: 'Edit PromoCode',
    },
    addPage: {
        id: 'app.addPage',
        defaultMessage: "Add Page",
        description: "Add Page"
    },
    id: {
        id: 'app.id',
        defaultMessage: 'ID',
        description: 'ID text',
    },
    title: {
        id: 'app.title',
        defaultMessage: 'Title',
        description: 'text',
    },
    description: {
        id: 'app.description',
        defaultMessage: 'Description',
        description: 'text',
    },
    code: {
        id: 'app.code',
        defaultMessage: 'Code',
        description: 'text',
    },
    discount: {
        id: 'app.discount',
        defaultMessage: 'Discount',
        description: 'text',
    },
    expireDate: {
        id: 'app.expireDate',
        defaultMessage: 'Expired Date',
        description: 'text',
    },
    manageCompletedBooking: {
        id: 'app.manageCompletedBooking',
        defaultMessage: 'Manage Completed Jobs',
        description: 'CompletedBooking sidemenu',
    },
    manageCancelledBookings: {
        id: 'app.manageCancelledBookings',
        defaultMessage: 'Manage Cancelled Jobs',
        description: 'manageCancelledBookings sidemenu',
    },
    manageCancelReason: {
        id: 'app.manageCancelReason',
        defaultMessage: 'Manage Cancel Reasons',
        description: 'Cancel Reason',
    },
    manageCurrency: {
        id: 'app.manageCurrency',
        defaultMessage: 'Manage Currency',
        description: 'manageCurrency sidemenu',
    },
    symbol: {
        id: 'app.symbol',
        defaultMessage: 'Symbol',
        description: 'currencyManagement value',
    },
    baseCurrency: {
        id: 'app.BaseCurrency',
        defaultMessage: 'Base Currency',
        description: 'currencyManagement value',
    },
    enableDisable: {
        id: 'app.enableDisable',
        defaultMessage: 'Set Enable / Disable',
        description: 'currencyManagement value',
    },
    setBaseCurrency: {
        id: 'app.setBaseCurrency',
        defaultMessage: 'Set Base Currency',
        description: 'currencyManagement value',
    },
    noResult: {
        id: 'app.noResult',
        defaultMessage: 'No results found',
        description: 'noResult'
    },
    addLocation: {
        id: 'app.addLocation',
        defaultMessage: 'Add Location',
        description: 'addLocation'
    },
    location: {
        id: 'app.location',
        defaultMessage: 'Manage Locations',
        description: 'location'
    },
    edit: {
        id: 'app.edit',
        defaultMessage: 'Edit',
        description: 'edit'
    },
    managePayout: {
        id: 'app.managePayout',
        defaultMessage: 'Manage Payout',
        description: 'managePayout'
    },
    partnerPayout: {
        id: 'app.partnerPayout',
        defaultMessage: 'Service Provider Payout',
        description: 'managePayout'
    },
    amount: {
        id: 'app.Amount',
        defaultMessage: 'Amount',
        description: 'Amount'
    },
    payoutStatus: {
        id: 'app.payoutStatus',
        defaultMessage: 'Payout Status',
        description: 'Payout Status'
    },
    holdPayout: {
        id: 'app.holdPayout',
        defaultMessage: 'Hold Payout',
        description: 'Hold Payout'
    },
    yes: {
        id: 'app.yes',
        defaultMessage: 'Yes',
        description: 'Yes'
    },
    no: {
        id: 'app.no',
        defaultMessage: 'No',
        description: 'no'
    },
    homeSectionSettings: {
        id: 'app.homeSectionSettings',
        defaultMessage: 'Banner',
        description: 'Banner Settings'
    },
    homepageBanner: {
        id: 'app.homepageBanner',
        defaultMessage: 'Homepage Banner',
        description: 'Homepage Banner Settings'
    },
    aboutSectionSettings: {
        id: 'app.aboutSectionSettings',
        defaultMessage: 'Top Features',
        description: 'Top Features Settings'
    },
    citySectionSettings: {
        id: 'app.citySectionSettings',
        defaultMessage: 'Category',
        description: 'Category Settings'
    },
    safetySectionSettings: {
        id: 'app.safetySectionSettings',
        defaultMessage: 'User App',
        description: 'User Apps Settings'
    },
    signupSectionSettings: {
        id: 'app.signupSectionSettings',
        defaultMessage: 'Service Provider App',
        description: 'Service Provider Apps Settings'
    },
    footerSectionSettings: {
        id: 'app.footerSectionSettings',
        defaultMessage: 'Footer',
        description: 'Footer Settings'
    },
    manageFailedPayout: {
        id: 'app.manageFailedPayout',
        defaultMessage: 'Manage Failed Payout',
        description: 'Failed Payout'
    },
    content: {
        id: 'app.content',
        defaultMessage: 'Content',
        description: 'Content 1'
    },
    aboutImage1: {
        id: 'app.aboutImage1',
        defaultMessage: 'Feature Icon #1',
        description: 'Feature Icon 1'
    },
    aboutImage2: {
        id: 'app.aboutImage2',
        defaultMessage: 'Feature Icon #2',
        description: 'Feature Icon 2'
    },
    homeImage1: {
        id: 'app.homeImage1',
        defaultMessage: 'Banner Image #1',
        description: 'Banner Image 1'
    },
    homeImage2: {
        id: 'app.homeImage2',
        defaultMessage: 'Banner Image #2',
        description: 'Banner Image 2'
    },
    homeTitle: {
        id: 'app.homeTitle',
        defaultMessage: 'Banner Title',
        description: 'Banner Title'
    },
    safetyImage1: {
        id: 'app.safetyImage1',
        defaultMessage: 'Playstore Logo',
        description: 'Playstore Logo'
    },
    safetyImage2: {
        id: 'app.safetyImage2',
        defaultMessage: 'Appstore Logo',
        description: 'Appstore Logo'
    },
    safetyImage3: {
        id: 'app.safetyImage3',
        defaultMessage: 'User App Image',
        description: 'User App Image'
    },
    signupImage1: {
        id: 'app.signupImage1',
        defaultMessage: 'Play Store Logo',
        description: 'Playstore Logo'
    },
    signupImage2: {
        id: 'app.signupImage2',
        defaultMessage: 'App Store Logo',
        description: 'Appstore Logo'
    },
    signupImage3: {
        id: 'app.signupImage3',
        defaultMessage: 'Service Provider App Image',
        description: 'Service provider App Image'
    },
    earnings: {
        id: 'app.earnings',
        defaultMessage: 'Your Earnings',
        description: 'Earnings'
    },
    overAll: {
        id: 'app.overAll',
        defaultMessage: 'Overall',
        description: 'Overall'
    },
    approve: {
        id: 'app.approve',
        defaultMessage: 'Approve',
        description: 'Approve'
    },
    decline: {
        id: 'app.decline',
        defaultMessage: 'Decline',
        description: 'Decline'
    },
    online: {
        id: 'app.online',
        defaultMessage: 'Online',
        description: 'online'
    },
    offline: {
        id: 'app.offline',
        defaultMessage: 'Offline',
        description: 'offline'
    },
    eligibleForAService: {
        id: 'app.eligibleForAService',
        defaultMessage: 'Eligible for a Service',
        description: 'text'
    },
    notEligibleForAService: {
        id: 'app.notEligibleForAService',
        defaultMessage: 'Not eligible for a Service',
        description: 'text'
    },
    preview: {
        id: 'app.preview',
        defaultMessage: 'Preview',
        description: 'Preview'
    },
    pageName: {
        id: 'app.pageName',
        defaultMessage: 'Page Name',
        description: 'Page Name'
    },
    staticpageManagement: {
        id: 'app.staticpageManagement',
        defaultMessage: 'Static Content Pages',
        description: 'Manage Static Content'
    },
    contentpageManagement: {
        id: 'app.contentpageManagement',
        defaultMessage: 'Primary Content Pages',
        description: 'Content Management'
    },
    editPageDetails: {
        id: 'app.editPageDetails',
        defaultMessage: 'Edit Page Details',
        description: 'Edit Page Details'
    },
    pageBanner: {
        id: 'app.pageBanner',
        defaultMessage: 'Page Banner',
        description: 'Page Banner'
    },
    pageImageBanner: {
        id: 'app.pageImageBanner',
        defaultMessage: 'Page Image Banner',
        description: 'Page Image Banner'
    },
    manageFare: {
        id: 'app.manageFare',
        defaultMessage: 'Manage Fares',
        description: 'Admin sidemenu'
    },
    locationName: {
        id: 'app.locationName',
        defaultMessage: 'Location',
        description: 'Table header'
    },
    addFare: {
        id: 'app.addFare',
        defaultMessage: 'Add Fare',
        description: 'Button '
    },
    editFare: {
        id: 'app.adeditFaredFare',
        defaultMessage: 'Edit Fare',
        description: 'Button '
    },
    paid: {
        id: 'app.paid',
        defaultMessage: 'Paid',
        description: 'Paid'
    },
    unpaid: {
        id: 'app.unpaid',
        defaultMessage: 'Unpaid',
        description: 'Unpaid'
    },
    payoutAmount: {
        id: 'app.payoutAmount',
        defaultMessage: 'Payout Amount',
        description: 'Payout Amount'
    },
    searchLocation: {
        id: 'app.searchLocation',
        defaultMessage: 'Search Location',
        description: 'Auto-Complete input'
    },
    removeLocation: {
        id: 'app.removeLocation',
        defaultMessage: 'Remove Location',
        description: 'Polygon remove'
    },
    walletBalance: {
        id: 'app.walletBalance',
        defaultMessage: 'Wallet Balance',
        description: 'Wallet Balance'
    },
    paymentMethod: {
        id: 'app.paymentMethod',
        defaultMessage: 'Payment Method',
        description: 'Payment Method'
    },
    card: {
        id: 'app.card',
        defaultMessage: 'Card',
        description: 'Card'
    },
    cash: {
        id: 'app.cash',
        defaultMessage: 'Cash',
        description: 'Cash'
    },
    wallet: {
        id: 'app.wallet',
        defaultMessage: 'Wallet',
        description: 'Wallet'
    },
    exportDataIntoCSV: {
        id: 'app.exportDataIntoCSV',
        defaultMessage: 'Export Data into CSV',
        description: 'Export Data into CSV',
    },
    roleName: {
        id: 'app.roleName',
        defaultMessage: 'Role Name',
        description: 'Role Name',
    },
    privileges: {
        id: 'app.privileges',
        defaultMessage: 'Privileges',
        description: 'Privileges',
    },
    emailText: {
        id: 'app.emailText',
        defaultMessage: 'Email',
        description: 'Email',
    },
    adminRole: {
        id: 'app.adminRole',
        defaultMessage: 'Admin Role',
        description: 'Admin Role',
    },
    adminName: {
        id: 'app.adminName',
        defaultMessage: 'Name',
        description: 'Name'
    },
    passwordText: {
        id: 'app.passwordText',
        defaultMessage: 'Provide new password only. Ignore this field to use the existing password for this user.',
        description: 'Password Content',
    },
    selectRole: {
        id: 'app.selectRole',
        defaultMessage: 'Select Role',
        description: 'Select Role',
    },
    role: {
        id: 'app.role',
        defaultMessage: 'Role',
        description: 'Role',
    },
    manageAdmin: {
        id: 'app.manageAdmin',
        defaultMessage: 'Manage Admins',
        description: 'Manage Admins',
    },
    manageAdminUsers: {
        id: 'app.manageAdminUsers',
        defaultMessage: 'Manage Admin Users',
        description: 'Manage Admin Users',
    },
    manageAdminRoles: {
        id: 'app.manageAdminRoles',
        defaultMessage: 'Manage Admin Roles',
        description: 'Manage Admin Roles',
    },
    addNewLabel: {
        id: 'app.addNewLabel',
        defaultMessage: 'Add New',
        description: 'Add New',
    },
    chooseLanguageLabel: {
        id: 'app.chooseLanguageLabel',
        defaultMessage: 'Choose a language',
        description: 'Choose a language',
    },
    askQuestion: {
        id: 'app.askQuestion',
        defaultMessage: 'Ask a question',
        description: 'Ban Status'
    },
    reportIssue: {
        id: 'app.reportIssue',
        defaultMessage: 'Report an issue',
        description: 'Ban Status'
    },
    Enabled: {
        id: 'app.Enabled',
        defaultMessage: 'Enabled',
        description: 'Ban Status'
    },
    Disabled: {
        id: 'app.Disabled',
        defaultMessage: 'Disabled',
        description: 'Ban Status'
    },
    Enable: {
        id: 'app.Enable',
        defaultMessage: 'Enable',
        description: 'Ban Status'
    },
    Disable: {
        id: 'app.Disable',
        defaultMessage: 'Disable',
        description: 'Ban Status'
    },
    setBase: {
        id: 'app.setBase',
        defaultMessage: 'Set as base currency',
        description: 'Ban Status'
    },
    Support: {
        id: 'app.Support',
        defaultMessage: 'Support',
        description: 'Ban Status'
    },
    notFound: {
        id: 'app.notFound',
        defaultMessage: 'Sorry, the page you were trying to view does not exist.',
        description: 'Ban Status'
    },
    oneOne: {
        id: 'app.oneOne',
        defaultMessage: 'One',
        description: 'Ban Status'
    },
    currencies: {
        id: 'app.currencies',
        defaultMessage: 'Currencies',
        description: 'Ban Status'
    },
    fares: {
        id: 'app.fares',
        defaultMessage: 'Fares',
        description: 'Fares'
    },
    homeonly: {
        id: 'app.homeonly',
        defaultMessage: 'Home',
        description: 'Fares'
    },
    allonly: {
        id: 'app.allonly',
        defaultMessage: 'All',
        description: 'Fares'
    },
    playstorelink: {
        id: 'app.playstorelink',
        defaultMessage: 'Play Store Link',
        description: 'Fares'
    },
    appstorelink: {
        id: 'app.appstorelink',
        defaultMessage: 'App Store Link',
        description: 'Fares'
    },
    partnerappcntn: {
        id: 'app.partnerappcntn',
        defaultMessage: 'Service Provider App Content',
        description: 'Fares'
    },
    partnerapptitle: {
        id: 'app.partnerapptitle',
        defaultMessage: 'Service Provider App Title',
        description: 'Fares'
    },
    processedCash: {
        id: 'app.processedCash',
        defaultMessage: 'Processed via cash',
        description: 'Label'
    },
    completedLabel: {
        id: 'app.completedLabel',
        defaultMessage: 'Completed',
        description: 'Label'
    },
    pendingLabel: {
        id: 'app.pendingLabel',
        defaultMessage: 'Pending',
        description: 'Label'
    },
    siteName: {
        id: 'app.siteName',
        defaultMessage: 'Site Name',
        description: 'Fares'
    },
    siteTitle: {
        id: 'app.siteTitle',
        defaultMessage: 'Site Title',
        description: 'Fares'
    },
    metakey: {
        id: 'app.metakey',
        defaultMessage: 'Meta Keyword',
        description: 'Fares'
    },
    metaDesc: {
        id: 'app.metaDesc',
        defaultMessage: 'Meta Description',
        description: 'Fares'
    },
    errorOnly: {
        id: 'app.errorOnly',
        defaultMessage: 'Error',
        description: 'Fares'
    },
    credentialError: {
        id: 'app.credentialError',
        defaultMessage: 'Sorry, a critical error occurred on this page.',
        description: 'Fares'
    },
    addOnly: {
        id: 'app.addOnly',
        defaultMessage: 'Address',
        description: 'Fares'
    },
    state: {
        id: 'app.state',
        defaultMessage: 'State',
        description: 'Fares'
    },
    checkmein: {
        id: 'app.checkmein',
        defaultMessage: 'Check me in',
        description: 'Fares'
    },
    checkmeout: {
        id: 'app.checkmeout',
        defaultMessage: 'Check me out',
        description: 'Fares'
    },
    tableHead: {
        id: 'app.tableHead',
        defaultMessage: 'Table heading',
        description: 'Fares'
    },
    tableCell: {
        id: 'app.tableCell',
        defaultMessage: 'Table cell',
        description: 'Fares'
    },
    confirmPassword: {
        id: 'app.confirmPassword',
        defaultMessage: 'Confirm Password',
        description: 'Change Password'
    },
    nameOnly: {
        id: 'app.nameOnly',
        defaultMessage: 'Name',
        description: 'Change Password'
    },
    msgOnly: {
        id: 'app.msgOnly',
        defaultMessage: 'Message',
        description: 'Change Password'
    },
    featureTitle1: {
        id: 'app.featureTitle1',
        defaultMessage: 'Feature title',
        description: 'Change Password'
    },
    featureDesc1: {
        id: 'app.featureDesc1',
        defaultMessage: 'Feature description',
        description: 'Change Password'
    },
    footerTitle1: {
        id: 'app.footerTitle1',
        defaultMessage: 'Footer Title #1',
        description: 'Change Password'
    },
    footerContent1: {
        id: 'app.footerContent1',
        defaultMessage: 'Footer Content #1',
        description: 'Change Password'
    },
    footerUrltitle: {
        id: 'app.footerUrltitle',
        defaultMessage: 'Footer URL Title',
        description: 'Change Password'
    },
    copyRightcontent: {
        id: 'app.copyRightcontent',
        defaultMessage: 'Copyrights content',
        description: 'Change Password'
    },
    radioButton: {
        id: 'app.radioButton',
        defaultMessage: 'Radio button',
        description: 'Change Password'
    },
    userApptitle: {
        id: 'app.userApptitle',
        defaultMessage: 'User App Title',
        description: 'Change Password'
    },
    userAppContent: {
        id: 'app.userAppContent',
        defaultMessage: 'User App Content',
        description: 'Change Password'
    },
    leaveEmail: {
        id: 'app.leaveEmail',
        defaultMessage: 'Leave email address field blank if you don\'t want to change the email',
        description: 'Change Password'
    },
    searchOnly: {
        id: 'app.searchOnly',
        defaultMessage: 'Search',
        description: 'Change Password'
    },
    add: {
        id: 'app.add',
        defaultMessage: 'Add',
        description: 'Add Button',
    },
    topFeatures: {
        id: 'app.topFeatures',
        defaultMessage: 'Top Features Section Settings',
        description: 'Top Features Section Settings',
    },
    managePartnerPayout: {
        id: 'app.managePartnerPayout',
        defaultMessage: 'Manage Service Provider Payouts',
        description: 'Manage Service Provider Payouts'
    },
    changeAdminPassword: {
        id: 'app.changeAdminPassword',
        defaultMessage: 'Change Admin Email/Password',
        description: 'Change Admin Email/Password'
    },
    currencyList: {
        id: 'app.currencyList',
        defaultMessage: 'Manage Currency',
        description: 'Manage Currency'
    },
    editLocation: {
        id: 'app.editLocation',
        defaultMessage: 'Edit Location',
        description: 'Edit Location'
    },
    bookingDetails: {
        id: 'app.bookingDetails',
        defaultMessage: 'Booking Details',
        description: 'Booking Details'
    },
    userAndriodVersion: {
        id: 'app.userAndriodVersion',
        defaultMessage: 'User Android Version',
        description: 'userAndriodVersion'
    },
    useriosVersion: {
        id: 'app.useriosVersion',
        defaultMessage: 'User iOS Version',
        description: 'useriosVersion'
    },
    partnerAndriodVersion: {
        id: 'app.partnerAndriodVersion',
        defaultMessage: 'Service Provider Android Version',
        description: 'Andriod'
    },
    partneriosVersion: {
        id: 'app.partneriosVersion',
        defaultMessage: 'Service Provider iOS Version',
        description: 'iOS'
    },
    forceUpdate: {
        id: 'app.forceUpdate',
        defaultMessage: 'Force update',
        description: 'forceUpdate'
    },
    invalidVersionNumber: {
        id: 'app.invalidVersionNumber',
        defaultMessage: 'Invalid Version Number',
        description: 'invalidVersionNumber'
    },
    to: {
        id: 'app.to',
        defaultMessage: 'To',
        description: 'Label'
    },
    validatePasswordLength: {
        id: 'app.validatePasswordLength',
        defaultMessage: 'Password must be minimum 8 characters',
        description: 'Password length Validation'
    },
    validateConfirmPasswordLength: {
        id: 'app.validateConfirmPasswordLength',
        defaultMessage: 'Confirm Password must be minimum 8 characters',
        description: 'Confirm Password length Validation'
    },
    validatePasswordMatch: {
        id: 'app.validatePasswordMatch',
        defaultMessage: 'Password is mismatching with Confirm password',
        description: 'Password mismatch'
    },
    itemTotal: {
        id: 'app.itemTotal',
        defaultMessage: 'Item Total',
        description: 'Label'
    },
    userBillingInformation: {
        id: 'app.userBillingInformation',
        defaultMessage: 'User Billing Information',
        description: 'Label'
    },
    partnerBillingInformation: {
        id: 'app.partnerBillingInformation',
        defaultMessage: 'Service Provider Billing Information',
        description: 'Label'
    },
    tipsReceivedFromUser: {
        id: 'app.tipsReceivedFromUser',
        defaultMessage: 'Tips received from the user',
        description: 'Label'
    },
    tipsGivenToPartner: {
        id: 'app.tipsGivenToPartner',
        defaultMessage: 'Tips given to the service provider',
        description: 'Label'
    },
    platformEarnings: {
        id: 'app.platformEarnings',
        defaultMessage: 'Platform Earnings',
        description: 'Label'
    },
    platformOffered: {
        id: 'app.platformOffered',
        defaultMessage: 'Platform Overdrafts',
        description: 'Label'
    },
    addAdminRole: {
        id: 'app.addAdminRole',
        defaultMessage: 'Add Admin Role',
        description: 'Title'
    },
    editAdminRole: {
        id: 'app.editAdminRole',
        defaultMessage: 'Edit Admin Role',
        description: 'Title'
    },
    locations: {
        id: 'app.locations',
        defaultMessage: 'Locations',
        description: 'Pagination'
    },
    addAdminUserLabel: {
        id: 'app.addAdminUserLabel',
        defaultMessage: 'Add Admin User',
        description: 'Add Admin User'
    },
    editAdminUserLabel: {
        id: 'app.editAdminUserLabel',
        defaultMessage: 'Edit Admin User',
        description: 'Edit Admin User'
    },
    completed: {
        id: 'app.completed',
        defaultMessage: 'Completed',
        description: 'Completed Status'
    },
    approved: {
        id: 'app.approved',
        defaultMessage: 'Approved',
        description: 'Approved Status'
    },
    declined: {
        id: 'app.declined',
        defaultMessage: 'Declined',
        description: 'Declined Status'
    },
    started: {
        id: 'app.started',
        defaultMessage: 'Started',
        description: 'Started Status'
    },
    cancelledByUser: {
        id: 'app.cancelledByUser',
        defaultMessage: 'Cancelled by user',
        description: 'Cancelled By User Status'
    },
    cancelledByPartner: {
        id: 'app.cancelledByPartner',
        defaultMessage: 'Cancelled by service provider',
        description: 'Cancelled By Service Provider Status'
    },
    expired: {
        id: 'app.expired',
        defaultMessage: 'Expired',
        description: 'Expired Status'
    },
    notRequiredMessage: {
        id: 'app.notRequiredMessage',
        defaultMessage: 'Not Required',
        description: 'Not Required'
    },
    partnerPrivacyPolicy: {
        id: 'app.partnerPrivacyPolicy',
        defaultMessage: 'Service Provider Privacy Policy',
        description: 'Title',
    },
    precautionNotification: {
        id: 'app.precautionNotification',
        defaultMessage: 'Manage Precaution Notification',
        description: 'Title',
    },
    image: {
        id: 'app.image',
        defaultMessage: 'Image',
        description: 'Label',
    },
    updatedAt: {
        id: 'app.updatedAt',
        defaultMessage: 'Updated At',
        description: 'Label'
    },
    chatLabel: {
        id: 'app.chatLabel',
        defaultMessage: 'Chat',
        description: 'Chat'
    },
    chatMessageLabel: {
        id: 'app.chatMessageLabel',
        defaultMessage: 'Chat Message',
        description: 'Chat Message'
    },
    stripePublishableKey: {
        id: 'app.stripePublishableKey',
        defaultMessage: 'Stripe publishable key',
        description: 'Stripe Publishable Key'
    },
    loadMoreMsg: {
        id: 'app.loadMoreMsg',
        defaultMessage: 'Load More',
        description: 'Load more button',
    },
    /**Loaded dynamically in View booking */
    km: {
        id: 'app.km',
        defaultMessage: 'Km',
        description: 'Km',
    },
    mile: {
        id: 'app.mile',
        defaultMessage: 'Mile',
        description: 'Mile',
    },
    /**Loaded dynamically in View booking */
    tracking: {
        id: 'app.tracking',
        defaultMessage: 'Tracking',
        description: 'tracking',
    },
    mapView: {
        id: 'app.mapView',
        defaultMessage: 'Map View',
        description: 'mapView',
    },
    heatMap: {
        id: 'app.heatMap',
        defaultMessage: 'HeatMap',
        description: 'heatMap',
    },
    all: {
        id: 'app.all',
        defaultMessage: 'All',
        description: 'all',
    },
    availablePartners: {
        id: 'app.availablePartners',
        defaultMessage: 'Available Service Providers',
        description: 'availablePartners',
    },
    unAvailablePartners: {
        id: 'app.unAvailablePartners',
        defaultMessage: 'Unavailable Service Providers',
        description: 'unAvailablePartners',
    },
    unActivatedPartners: {
        id: 'app.unActivatedPartners',
        defaultMessage: 'Unactivated Service Providers',
        description: 'unActivatedPartners',
    },
    mobileSettings: {
        id: 'app.mobileSettings',
        defaultMessage: 'Mobile App Settings',
        description: 'Mobile App Settings'
    },
    notificationInterval: {
        id: 'app.notificationInterval',
        defaultMessage: 'Job acceptance time for the service provider',
        description: 'notificationInterval'
    },
    sleepPartnerAndroid: {
        id: 'app.sleepPartnerAndroid',
        defaultMessage: 'Service Provider Android App',
        description: 'sleepPartnerAndroid'
    },
    sleepPartnerios: {
        id: 'app.sleepPartnerios',
        defaultMessage: 'Service Provider iOS App ',
        description: 'sleepPartnerios'
    },
    show: {
        id: 'app.show',
        defaultMessage: 'Show',
        description: 'show'
    },
    hide: {
        id: 'app.hide',
        defaultMessage: 'Hide',
        description: 'hide'
    },
    jobRequestWindow: {
        id: 'app.jobRequestWindow',
        defaultMessage: "Manage service provider app's job request window information",
        description: 'jobRequestWindow'
    },
    sleepMode: {
        id: 'app.sleepMode',
        defaultMessage: 'Manage Service Provider App Sleep Mode',
        description: 'sleepMode'
    },
    stripeSettings: {
        id: 'app.stripeSettings',
        defaultMessage: 'Stripe account settings',
        description: 'stripeSettings'
    },
    manageForceUpdate: {
        id: 'app.manageForceUpdate',
        defaultMessage: 'Manage Apps Force Update',
        description: 'manageForceUpdate'
    },
    allowableDistaceTitle: {
        id: 'app.allowableDistaceTitle',
        defaultMessage: 'Maximum distance to cover while fetching service providers',
        description: 'allowableDistaceTitle'
    },
    allowedServices: {
        id: 'app.allowedServices',
        defaultMessage: 'Maximum sub-categories that the users can select while requesting a job',
        description: 'allowedServices'
    },
    invalid: {
        id: 'app.invalid',
        defaultMessage: 'Invalid',
        description: 'invalid'
    },
    markerInfo: {
        id: 'app.markerInfo',
        defaultMessage: 'Marker Info',
        description: 'Marker Info'
    },
    favIconlogoLabel: {
        id: 'app.favIconlogoLabel',
        defaultMessage: 'Fav Icon',
        description: 'Fav Icon'
    },
    contactPhoneNumber: {
        id: 'app.contactPhoneNumber',
        defaultMessage: 'Contact phone number',
        description: 'contactPhoneNumber'
    },
    contactEmail: {
        id: 'app.contactEmail',
        defaultMessage: 'Contact email',
        description: 'contactEmail'
    },
    skype: {
        id: 'app.skype',
        defaultMessage: 'Skype',
        description: 'skype'
    },
    last7Days: {
        id: 'app.last7Days',
        defaultMessage: 'Last 7 days',
        description: 'select label'
    },
    allDays: {
        id: 'app.allDays',
        defaultMessage: 'All days',
        description: 'select label'
    },
    last30Days: {
        id: 'app.last30Days',
        defaultMessage: 'Last 30 days',
        description: 'select label'
    },
    addCurrency: {
        id: 'app.addCurrency',
        defaultMessage: 'Add currency',
        description: 'addCurrency'
    },
    legal: {
        id: 'app.legal',
        defaultMessage: 'Legal',
        description: 'legal',
    },
    fixedFareType: {
        id: 'app.fixedFareType',
        defaultMessage: 'Fixed fare Type',
        description: 'Fixed fare Type'
    },
    hourlyFareType: {
        id: 'app.hourlyFareType',
        defaultMessage: 'Hourly fare type',
        description: 'Hourly fare type'
    },
    subCategoryMenu: {
        id: 'app.subCategoryMenu',
        defaultMessage: 'Manage Sub-categories',
        description: 'Manage SubCategory'
    },
    name: {
        id: 'app.name',
        defaultMessage: 'Name',
        description: 'name',
    },
    addSubCategory: {
        id: 'app.addSubCategory',
        defaultMessage: 'Add Sub Category',
        description: 'Add subcategory form header'
    },
    editSubCategory: {
        id: 'app.editSubCategory',
        defaultMessage: 'Edit Sub Category',
        description: 'Edit subcategory form header'
    },
    isPriceEditable: {
        id: 'app.isPriceEditable',
        defaultMessage: 'Can be editable by service provider?',
        description: 'Can be editable by service provider?',
    },
    hourlyPrice: {
        id: 'app.hourlyPrice',
        defaultMessage: 'Hourly Price',
        description: 'Hourly Price'
    },
    maxQuantity: {
        id: 'app.maxQuantity',
        defaultMessage: 'Maximum Quantity ',
        description: 'Maximum Quantity ',
    },
    minHours: {
        id: 'app.minHours',
        defaultMessage: 'Minimum Hours',
        description: 'Minimum Hours',
    },
    travelCharge: {
        id: 'app.travelCharge',
        defaultMessage: 'Visit Fee',
        description: 'Travelling Charge',
    },
    subCategory: {
        id: 'app.subCategory',
        defaultMessage: 'Sub Category',
        description: 'SubCategory'
    },
    subCategoryName: {
        id: 'app.subCategoryName',
        defaultMessage: 'Sub Category Name',
        description: 'subCategoryName'
    },
    backGroundImage: {
        id: 'app.subCatbackGroundImageegoryName',
        defaultMessage: 'Background Image',
        description: 'backGroundImage'
    },
    maximumEmergencyContact: {
        id: 'app.maximumEmergencyContact',
        defaultMessage: 'Maximum Emergency Contact',
        description: 'maximumEmergencyContact'
    },
    promoCodeImage: {
        id: 'app.promoCodeImage',
        defaultMessage: 'Promo Code Image',
        description: 'title'
    },
    userIdentity: {
        id: 'app.userIdentity',
        defaultMessage: 'User Identity',
        description: 'userIdentity'
    },
    userExperience: {
        id: 'app.userExperience',
        defaultMessage: 'User Experience',
        description: 'userExperience'
    },
    welcomeAdminLabel: {
        id: 'app.welcomeAdminLabel',
        defaultMessage: 'Welcome Admin !!!',
        description: 'Welcome Admin !!!',
    },
    duration: {
        id: 'app.duration',
        defaultMessage: 'Job acceptance time',
        description: 'duration'
    },
    job: {
        id: 'app.job',
        defaultMessage: 'Job list',
        description: 'job'
    },
    jobDescription: {
        id: 'app.jobDescription',
        defaultMessage: 'Job description',
        description: 'jobDescription'
    },
    jobPhoto: {
        id: 'app.jobPhoto',
        defaultMessage: 'Job photos',
        description: 'hide'
    },
    estimatedPrice: {
        id: 'app.estimatedPrice',
        defaultMessage: 'Estimated price',
        description: 'estimatedPrice'
    },
    jobLocation: {
        id: 'app.jobLocation',
        defaultMessage: 'Job location',
        description: 'jobLocation'
    },
    validateInterval: {
        id: 'app.validateInterval',
        defaultMessage: 'Notification interval must be greater than 0.5 min',
        description: 'validateInterval'
    },
    userNumber: {
        id: 'app.userNumber',
        defaultMessage: 'User Phone Number',
        description: 'User Number'
    },
    partnerNumber: {
        id: 'app.partnerNumber',
        defaultMessage: 'Service Provider Phone Number',
        description: 'Service Provider Number'
    },
    additionalFee: {
        id: 'app.additionalFee',
        defaultMessage: 'Additional Charge',
        description: 'Additional Charge',
    },
    serviceFee: {
        id: 'app.serviceFee',
        defaultMessage: 'Service Fee',
        description: 'serviceFee ',
    },
    earningsLabel: {
        id: 'app.earningsLabel',
        defaultMessage: 'Earnings',
        description: 'Earnings'
    },
    jobProgress: {
        id: 'app.jobProgress',
        defaultMessage: 'Job Progress',
        description: 'jobProgress'
    },
    jobDetails: {
        id: 'app.jobDetails',
        defaultMessage: 'Job Details',
        description: 'jobDetails'
    },
    totalWorkingHours: {
        id: 'app.totalWorkingHours',
        defaultMessage: 'Total working hours =',
        description: 'Total working hours '
    },
    requestCreated: {
        id: 'app.requestCreated',
        defaultMessage: 'Request Created',
        description: 'Request Created'
    },
    requestAccepted: {
        id: 'app.requestAccepted',
        defaultMessage: 'Request Accepted',
        description: 'Request Accepted'
    },
    arrived: {
        id: 'app.arrived',
        defaultMessage: 'Arrived',
        description: 'Arrived'
    },
    requestReviewed: {
        id: 'app.requestReviewed',
        defaultMessage: 'Request Reviewed',
        description: 'Request Reviewed'
    },
    requestCancelled: {
        id: 'app.requestCancelled',
        defaultMessage: 'Request Cancelled',
        description: 'Request Cancelled'
    },
    jobStarted: {
        id: 'app.jobStarted',
        defaultMessage: 'Job Started',
        description: 'Job Started'
    },
    jobCompleted: {
        id: 'app.jobCompleted',
        defaultMessage: 'Job Completed',
        description: 'Job Completed'
    },
    totalEarnings: {
        id: 'app.totalEarnings',
        defaultMessage: 'Total Earnings',
        description: 'Earnings'
    },
    requestDecline: {
        id: 'app.requestDecline',
        defaultMessage: 'Request Declined',
        description: 'Request Declined'
    },
    subCategories: {
        id: 'app.subCategories',
        defaultMessage: 'Sub Categories',
        description: 'subCategories'
    },
    viewJob: {
        id: 'app.viewJob',
        defaultMessage: 'View job',
        description: 'view Job',
    },
    jobId: {
        id: 'app.jobId',
        defaultMessage: 'Job ID',
        description: 'Job',
    },
    requestTone: {
        id: 'app.requestTone',
        defaultMessage: 'Request accept timer tone',
        description: 'requestTone'
    },
    uploadRequestTone: {
        id: 'app.uploadRequestTone',
        defaultMessage: 'Upload timer tone',
        description: 'uploadRequestTone'
    },
    appOpenRequest: {
        id: 'app.appOpenTrip',
        defaultMessage: 'Open the provider app when a request notification is received',
        description: 'appOpenTrip'
    },
    jobs: {
        id: 'app.jobs',
        defaultMessage: 'Jobs',
        description: 'jobs',
    },
    manageSmsMethod: {
        id: 'app.manageSmsMethod',
        defaultMessage: 'Manage SMS Settings',
        description: 'manageSmsMethod',
    },
    accountId: {
        id: 'app.accountId',
        defaultMessage: 'ACCOUNT SID',
        description: 'ACCOUNT_SID'
    },
    secretId: {
        id: 'app.secretId',
        defaultMessage: 'AUTHTOKEN',
        description: 'AUTHTOKEN'
    },
    apiKey: {
        id: 'app.apiKey',
        defaultMessage: 'API KEY',
        description: 'API KEY'
    },
    secretKey: {
        id: 'app.secretKey',
        defaultMessage: 'SECRET KEY',
        description: 'SECRET KEY'
    },
    noLimit: {
        id: 'app.noLimit',
        defaultMessage: 'No Limit',
        description: 'noLimit'
    },
    records: {
        id: 'app.records',
        defaultMessage: 'Records per page',
        description: 'records'
    },
    editSmsMethod: {
        id: 'app.editSmsMethod',
        defaultMessage: 'Edit SMS Settings',
        description: 'editSmsMethod',
    },
    receipt: {
        id: 'app.receipt',
        defaultMessage: 'Receipt',
        description: 'receipt'
    },
    manageSchedule: {
        id: 'app.manageSchedule',
        defaultMessage: 'Manage Schedule Jobs',
        description: 'manageSchedule'
    },
    scheduledFrom: {
        id: 'app.scheduledFrom',
        defaultMessage: 'Scheduled From',
        description: 'Label'
    },
    scheduledTo: {
        id: 'app.scheduledTo',
        defaultMessage: 'Scheduled To',
        description: 'Label'
    },
    scheduleBookingHistory: {
        id: 'app.scheduleBookingHistory',
        defaultMessage: 'Schedule Booking History',
        description: 'Heading'
    },
    validateScheduleInterval: {
        id: 'app.validateScheduleInterval',
        defaultMessage: 'Schedule interval must be greater than 20 min',
        description: 'validateScheduleInterval'
    },
    defaultScheduleInterval: {
        id: 'app.defaultScheduleInterval',
        defaultMessage: 'Default Schedule Interval',
        description: 'defaultScheduleInterval'
    },
    requestScheduled: {
        id: 'app.requestScheduled',
        defaultMessage: 'Request Scheduled',
        description: 'Request Scheduled'
    },
    minLableText: {
        id: 'app.minLableText',
        defaultMessage: 'min',
        description: 'min'
    },
    lightMode: {
        id: 'app.lightMode',
        defaultMessage: 'Light mode',
        description: 'Light mode',
    },
    darkMode: {
        id: 'app.darkMode',
        defaultMessage: 'Dark mode',
        description: 'Dark mode',
    },
    additionalWorkInterval: {
        id: 'app.additionalWorkInterval',
        defaultMessage: 'Additional work request acceptance time',
        description: 'additionalWorkInterval'
    },
    missedEarnings: {
        id: 'app.missedEarnings',
        defaultMessage: 'Missed earnings',
        description: 'missedEarnings'
    },
    smtpHost: {
        id: 'app.smtpHost',
        defaultMessage: 'SMTP host',
        description: 'smtpHost',
    },
    smtpPort: {
        id: 'app.smtpPort',
        defaultMessage: 'SMTP port',
        description: 'smtpPort',
    },
    smptEmail: {
        id: 'app.smptEmail',
        defaultMessage: 'SMTP email',
        description: 'smptEmail',
    },
    smtpSender: {
        id: 'app.smtpSender',
        defaultMessage: 'SMTP sender',
        description: 'smtpSender',
    },
    smtpSenderEmail: {
        id: 'app.smtpSenderEmail',
        defaultMessage: 'SMTP sender email',
        description: 'smtpSenderEmail',
    },
    smtpPassWord: {
        id: 'app.smtpPassWord',
        defaultMessage: 'SMTP password',
        description: 'smtpPassWord',
    },
    maxUploadLabel: {
        id: 'app.maxUploadLabel',
        defaultMessage: 'Maximum image upload size [ MB ]',
        description: 'maxUploadLabel',
    },
    manageSiteConfig: {
        id: 'app.manageSiteConfig',
        defaultMessage: 'Manage Site Configurations',
        description: 'manageSiteConfig',
    },
    smtpSettings: {
        id: 'app.smtpSettings',
        defaultMessage: 'SMTP settings',
        description: 'smtpSettings'
    },
    pushNotificationSettings: {
        id: 'app.pushNotificationSettings',
        defaultMessage: 'Push notification settings',
        description: 'pushNotificationSettings'
    },
    otherSettings: {
        id: 'app.otherSettings',
        defaultMessage: 'Other settings',
        description: 'manageConfigHeading',
    },
    managePaymentGateWay: {
        id: 'app.managePaymentGateWay',
        defaultMessage: 'Manage Payment Methods',
        description: 'Manage Payment Gateway',
    },
    paymentGateWay: {
        id: 'app.paymentGateWay',
        defaultMessage: 'Payment methods',
        description: 'Payment Gateway',
    },
    googlePay: {
        id: 'app.googlePay',
        defaultMessage: 'GooglePay',
        description: 'GooglePay',
    },
    fcmPushNotificationKey: {
        id: 'app.fcmPushNotificationKey',
        defaultMessage: 'FCM push notification key',
        description: 'fcmPushNotificationKey'
    },
    bookingMethods: {
        id: 'app.bookingMethods',
        defaultMessage: 'Booking methods',
        description: 'Mobile App Settings'
    },
    randomProviderSelection: {
        id: 'app.randomProviderSelection',
        defaultMessage: 'Random provider selection',
        description: 'Mobile App Settings'
    },
    preferredProviderSelection: {
        id: 'app.preferredProviderSelection',
        defaultMessage: 'Preferred provider selection',
        description: 'Mobile App Settings'
    },
    randomProviderSelectionTooltip: {
        id: 'app.randomProviderSelectionTooltip',
        defaultMessage: 'Allow the system to choose the available nearby service providers for the user\'s needs.',
        description: 'Mobile App Settings'
    },
    preferredProviderSelectionTooltip: {
        id: 'app.preferredProviderSelectionTooltip',
        defaultMessage: 'Allow the user to choose the preferred service provider from the nearby available service providers list and connect with them for their needs.',
        description: 'Mobile App Settings'
    },
    preferredServiceProviderCount: {
        id: 'app.preferredServiceProviderCount',
        defaultMessage: 'Preferred service provider count',
        description: 'preferredServiceProviderCount'
    },
    senderId: {
        id: 'app.senderId',
        defaultMessage: 'SENDER ID',
        description: 'SENDER_ID'
    },
    delete: {
        id: 'app.delete',
        defaultMessage: 'Delete',
        description: 'Delete Button',
    },
    addNew: {
        id: 'app.addNew',
        defaultMessage: 'Name',
        description: 'Name',
    },
    addNewDescription: {
        id: 'app.addNewDescription',
        defaultMessage: 'Description',
        description: 'description',
    },
    exceedCharLimit: {
        id: 'app.exceedCharLimit',
        defaultMessage: 'Maximum allowed character is 255.',
        description: 'exceedLimit',
    },
    emailBlankSpace: {
        id: 'app.emailBlankSpace',
        defaultMessage: 'Email should not be blank spaces',
        description: 'email address error',
    },
    passwordInvalid1: {
        id: 'app.passwordInvalid1',
        defaultMessage: 'Password should be minimum 8 characters.',
        description: 'Password minimum characters error',
    },
    passwordBlankSpace: {
        id: 'app.blankSpace',
        defaultMessage: 'Password should not be blank space.',
        description: 'Password error',
    },
    email: {
        id: 'app.email',
        defaultMessage: 'Email Address',
        description: 'Your Email Address to Login',
    },
    emailNotExists: {
        id: 'app.emailNotExists',
        defaultMessage: 'No account exists for this email. Make sure it\'s typed in correctly, or “sign up” instead',
        description: 'Email Address is not exist',
    },
    passwordWrong: {
        id: 'app.passwordWrong',
        defaultMessage: 'Wrong Password. Please try again',
        description: 'Wrong Password',
    },
    somethingWentWrong: {
        id: 'app.somethingWentWrong',
        defaultMessage: 'Sorry, something went wrong. Please try again',
        description: 'Wrong went wrong',
    },
    loggedIn: {
        id: 'app.loggedIn',
        defaultMessage: 'You are already logged in!',
        description: 'You are already Logged-in',
    },
    userLoggedIn: {
        id: 'app.userLoggedIn',
        defaultMessage: 'You are already logged in as User, please logout in the main site to continue!',
        description: 'You are already Logged-in as user',
    },
    inputTextLimitError: {
        id: 'app.inputTextLimitError',
        defaultMessage: 'Limit exceeded! you can add up to 250 characters',
        description: 'inputTextLimitError',
    },
    inputDescLimitError: {
        id: 'app.inputDescLimitError',
        defaultMessage: 'Limit exceeded! You can enter up to 10,000 characters',
        description: 'inputDescLimit',
    },
    chooseALanguage: {
        id: 'app.languageDropDownMessage',
        defaultMessage: 'Choose a language',
        description: 'Choose a language',
    },
    addLanguage: {
        id: 'app.addLanguage',
        defaultMessage: 'Add language',
        description: 'Add language'
    },
    deleteLanguage: {
        id: 'app.deleteLanguage',
        defaultMessage: 'Delete language',
        description: 'Delete language'
    },
    language: {
        id: 'app.language',
        defaultMessage: 'Language',
        description: 'Language'
    },
    addFeature: {
        id: 'app.addFeature',
        defaultMessage: 'Add feature',
        description: 'Top feature'
    },
    editFeature: {
        id: 'app.editFeature',
        defaultMessage: 'Edit feature',
        description: 'Top feature'
    },
    manualBookings: {
        id: 'app.manualBookings',
        defaultMessage: 'Manual Jobs',
        description: 'bookingsMenu',
    },
    addNewLableText: {
        id: 'app.addNewLableText',
        defaultMessage: 'Add new',
        description: 'bookingsMenu',
    },
    addNewBooking: {
        id: 'app.addNewBooking',
        defaultMessage: 'Add new booking',
        description: 'bookingsMenu',
    },
    next: {
        id: 'app.next',
        defaultMessage: 'Next',
        description: 'next',
    },
    bookNow: {
        id: 'app.bookNow',
        defaultMessage: 'Book now',
        description: 'bookNow',
    },
    schedule: {
        id: 'app.schedule',
        defaultMessage: 'Schedule',
        description: 'Schedule',
    },
    nameTextLimitError: {
        id: 'app.nameTextLimitError',
        defaultMessage: 'Limit exceeded! you can add up to 20 characters',
        description: 'nameTextLimitError',
    },
    editInfo: {
        id: 'app.editInfo',
        defaultMessage: 'Edit info',
        description: 'editInfo',
    },
    done: {
        id: 'app.done',
        defaultMessage: 'Done',
        description: 'done',
    },
    minHr: {
        id: 'app.minHr',
        defaultMessage: 'Min hr:',
        description: 'minHr',
    },
    maxQty: {
        id: 'app.maxQty',
        defaultMessage: 'Max Qty:',
        description: 'maxQty',
    },
    selectSubCategory: {
        id: 'app.selectSubCategory',
        defaultMessage: 'Select sub category',
        description: 'selectSubCategory',
    },
    autoAssignProvider: {
        id: 'app.autoAssignProvider',
        defaultMessage: 'Auto assign provider',
        description: 'Auto assign provider',
    },
    remove: {
        id: 'app.remove',
        defaultMessage: 'Remove',
        description: 'Remove'
    },
    priceSummary: {
        id: 'app.priceSummary',
        defaultMessage: 'Price summary',
        description: 'Price summary'
    },
    total: {
        id: 'app.total',
        defaultMessage: 'Total',
        description: 'Total'
    },
    reset: {
        id: 'app.reset',
        defaultMessage: 'Reset',
        description: 'Total'
    },
    autoAssignProviderContent: {
        id: 'app.autoAssignProviderContent',
        defaultMessage: 'By unchecking this box, you can choose the preferred service provider from the nearby available service providers list for the service request. The system will then connect with the selected service provider for your needs.',
        description: 'AutoAssignProviderContent'
    },
    vistFeeContent: {
        id: 'app.vistFeeContent',
        defaultMessage: 'This is a fee for a service provider to visit the user’s place',
        description: 'VistFee'
    },
    serviceFeeContent: {
        id: 'app.serviceFeeContent',
        defaultMessage: 'This is a fee which will be paid by the user for using the platform',
        description: 'ServiceFee'
    },
    cancelJob: {
        id: 'app.cancelJob',
        defaultMessage: 'Cancel job',
        description: 'CancelJob'
    },
    proceed: {
        id: 'app.proceed',
        defaultMessage: 'Proceed',
        description: 'Proceed'
    },
    cancelJobContent: {
        id: 'app.cancelJobContent',
        defaultMessage: 'You can cancel the job on behalf of the user or provider by using the following reasons',
        description: 'CancelJob'
    },
    canceledBy: {
        id: 'app.canceledBy',
        defaultMessage: 'Canceled by',
        description: 'Canceled By'
    },
    otherReasons: {
        id: 'app.otherReasons',
        defaultMessage: 'Other reasons',
        description: 'Other Reasons'
    },
    cancelBooking: {
        id: 'app.cancelBooking',
        defaultMessage: 'Cancel booking',
        description: 'Cancel Booking'
    },
    cancelScheduledBooking: {
        id: 'app.cancelScheduledBooking',
        defaultMessage: 'Are you sure do you want to cancel the schedule job?',
        description: 'Cancel Scheduled Booking'
    },
    close: {
        id: 'app.close',
        defaultMessage: 'Close',
        description: 'Close'
    },

    assignProvider: {
        id: 'app.assignProvider',
        defaultMessage: 'Assign provider',
        description: 'Assign provider'
    },

    completedServices: {
        id: 'app.completedServices',
        defaultMessage: 'Completed services:',
        description: 'Assign provider'
    },

    assign: {
        id: 'app.assign',
        defaultMessage: 'Assign',
        description: 'Assign provider'
    },

    searchByProviderPhone: {
        id: 'app.searchByProviderPhone',
        defaultMessage: 'Search by provider, Phone number',
        description: 'Assign provider'
    },

    noProviderAvailable: {
        id: 'app.noProviderAvailable',
        defaultMessage: 'Currently no service provider available!',
        description: 'Assign provider'
    },

    chooseDateTime: {
        id: 'app.chooseDateTime',
        defaultMessage: 'Choose date & Time',
        description: 'Schedule booking'
    },

    dateTime: {
        id: 'app.dateTime',
        defaultMessage: 'Date & Time',
        description: 'Schedule booking'
    },

    time: {
        id: 'app.time',
        defaultMessage: 'Time',
        description: 'Schedule booking'
    },

    selectDate: {
        id: 'app.selectDate',
        defaultMessage: 'Select date',
        description: 'Schedule booking'
    },

    date: {
        id: 'app.date',
        defaultMessage: 'Date',
        description: 'Schedule booking'
    },

    at: {
        id: 'app.at',
        defaultMessage: 'at',
        description: 'Schedule booking'
    },

    bookingScheduleOn: {
        id: 'app.bookingScheduleOn',
        defaultMessage: '*Booking scheduled on',
        description: 'Booking scheduled'
    },

    scheduleNow: {
        id: 'app.scheduleNow',
        defaultMessage: 'Scheduled now',
        description: 'Booking scheduled'
    },

    editDateTime: {
        id: 'app.editDateTime',
        defaultMessage: 'Edit date & Time',
        description: 'Schedule booking'
    },

    back: {
        id: 'app.back',
        defaultMessage: 'Back',
        description: 'Schedule booking'
    },
    preferredCurrency: {
        id: 'app.preferredCurrency',
        defaultMessage: 'Preferred currency',
        description: 'Preferred currency'
    },
    pageNotFound: {
        id: 'app.pageNotFound',
        defaultMessage: 'Page Not Found',
        description: 'Page Not Found'
    },
    selectPastDate: {
        id: 'app.selectPastDate',
        defaultMessage: 'You are only allowed to create a job request for future dates',
        description: 'Schedule booking'
    },

    scheduleAheadTime: {
        id: 'app.scheduleAheadTime',
        defaultMessage: 'Create a job request 20 minutes ahead of the current time',
        description: 'Schedule booking'
    },

    am: {
        id: 'app.am',
        defaultMessage: 'AM',
        description: 'time'
    },

    pm: {
        id: 'app.pm',
        defaultMessage: 'PM',
        description: 'time'
    },

    scheduled: {
        id: 'app.scheduled',
        defaultMessage: 'Scheduled',
        description: 'Scheduled'
    },
    mobileNumber: {
        id: 'app.mobileNumber',
        defaultMessage: 'Mobile Number',
        description: 'Mobile Number'
    },
    sendOTP: {
        id: 'app.sendOTP',
        defaultMessage: 'Send OTP',
        description: 'Send OTP'
    },
    otpVerify: {
        id: 'app.otpVerify',
        defaultMessage: 'Verify OTP',
        description: 'Verify OTP'
    },
    loginSignupLabel: {
        id: 'app.loginSignupLabel',
        defaultMessage: 'Login / Signup',
        description: 'Login/Signup',
    },
    mobileNumberLabel: {
        id: 'app.mobileNumberLabel',
        defaultMessage: 'Enter your mobile number',
        description: 'Enter your mobile number',
    },
    enterOtp: {
        id: 'app.enterOtp',
        defaultMessage: 'Enter the OTP sent to',
        description: 'Enter the OTP sent to',
    },
    otpLabel: {
        id: 'app.otpLabel',
        defaultMessage: 'Your OTP is 1234',
        description: 'Your OTP is 1234',
    },
    otpNotReceiveLabel: {
        id: 'app.otpNotReceiveLabel',
        defaultMessage: 'Didn\'t receive the OTP yet?',
        description: 'Didn\'t receive the OTP yet?',
    },
    resend: {
        id: 'app.resend',
        defaultMessage: 'Resend it',
        description: 'Resend it',
    },
    verify: {
        id: 'app.verify',
        defaultMessage: 'Verify',
        description: 'Verify',
    },
    otpRequired: {
        id: 'app.otpRequired',
        defaultMessage: 'Please enter valid OTP',
        description: 'Please enter valid OTP',
    },
    verifyNumberLabel: {
        id: 'app.verifyNumberLabel',
        defaultMessage: 'Verify your mobile number',
        description: 'Verify your mobile number',
    },
    firebaseLabel: {
        id: 'app.firebaseLabel',
        defaultMessage: 'Firebase',
        description: 'Firebase',
    },
    firebaseTooltip: {
        id: 'app.firebaseTooltip',
        defaultMessage: 'This section allows you to configure your push notification settings using Firebase Cloud Messaging (FCM). By enabling FCM, you can receive push notifications about service updates.',
        description: 'Tooltip'
    },
    fcmApiKey: {
        id: 'app.fcmApiKey',
        defaultMessage: 'FCM api key',
        description: 'FCM api key',
    },
    fcmAuthDomain: {
        id: 'app.fcmAuthDomain',
        defaultMessage: 'FCM auth domain',
        description: 'FCM auth domain',
    },
    fcmProjectId: {
        id: 'app.fcmProjectId',
        defaultMessage: 'FCM project ID',
        description: 'FCM project id',
    },
    fcmStorageBucket: {
        id: 'app.fcmStorageBucket',
        defaultMessage: 'FCM storage bucket',
        description: 'FCM storage bucket',
    },
    fcmMessagingSenderId: {
        id: 'app.fcmMessagingSenderId',
        defaultMessage: 'FCM messaging sender ID',
        description: 'FCM messaging sender id',
    },
    fcmAppId: {
        id: 'app.fcmAppId',
        defaultMessage: 'FCM app ID',
        description: 'FCM app id',
    },
    fcmMeasurementId: {
        id: 'app.fcmMeasurementId',
        defaultMessage: 'FCM measurement ID',
        description: 'FCM measurement id',
    },
    fcmVapidKey: {
        id: 'app.fcmVapidKey',
        defaultMessage: 'FCM vapid key',
        description: 'FCM vapid key',
    },
    fcmPushNotificationKeyTooltip: {
        id: 'app.fcmPushNotificationKeyTooltip',
        defaultMessage: 'It\'s nothing but a key which helps you to send push notifications. You can create a keys from your Firebase account',
        description: 'Tooltip'
    },
    firstNameText: {
        id: 'app.firstNameText',
        defaultMessage: 'First name',
        description: 'firstName',
    },
    lastNameText: {
        id: 'app.lastNameText',
        defaultMessage: 'Last name',
        description: 'lastName',
    },
    finishText: {
        id: 'app.finishText',
        defaultMessage: 'Finish',
        description: 'Finish',
    },
    emailText: {
        id: 'app.emailText',
        defaultMessage: 'Email',
        description: 'Email',
    },
    signupTitle: {
        id: 'app.signupTitle',
        defaultMessage: 'Let\'s get you started',
        description: 'Let\s get you started',
    },
    firstNameRequired: {
        id: 'app.firstNameRequired',
        defaultMessage: 'Please enter first name',
        description: 'Please enter first name',
    },
    lastNameRequired: {
        id: 'app.lastNameRequired',
        defaultMessage: 'Please enter last name',
        description: 'Please enter last name',
    },
    emailRequiredText: {
        id: 'app.emailRequiredText',
        defaultMessage: 'Please enter email',
        description: 'Please enter email',
    },
    locationRequired: {
        id: 'app.locationRequired',
        defaultMessage: 'Please select location',
        description: 'Please select location',
    },
    emailInvalidText: {
        id: 'app.emailInvalidText',
        defaultMessage: 'Please enter valid email',
        description: 'Please enter valid email',
    },
    welcomeDashboard: {
        id: 'app.welcomeDashboard',
        defaultMessage: 'Hii Welcome to your Dashboard',
        description: 'Hii Welcome to your Dashboard'
    },
    dashboard: {
        id: 'app.dashboard',
        defaultMessage: 'Dashboard',
        description: 'dashboard',
    },
    myBookings: {
        id: 'app.myBookings',
        defaultMessage: 'My bookings',
        description: 'My bookings',
    },
    paymentMethodText: {
        id: 'app.paymentMethodText',
        defaultMessage: 'Payment method',
        description: 'Payment method',
    },
    profile: {
        id: 'app.profile',
        defaultMessage: 'Profile',
        description: 'Profile',
    },
    welcomeBack: {
        id: 'app.welcomeBack',
        defaultMessage: 'Welcome Back,',
        description: 'Welcome Back,',
    },
    bookingContent: {
        id: 'app.bookingContent',
        defaultMessage: 'You can see your current and past booking on here',
        description: 'You can see your current and past booking on here',
    },
    paymentContent: {
        id: 'app.paymentContent',
        defaultMessage: 'You can change your payment method for booking',
        description: 'You can change your payment method for booking',
    },
    profileContent: {
        id: 'app.profileContent',
        defaultMessage: 'Easy to access your profile information on here',
        description: 'Easy to access your profile information on here',
    },
    allCategories: {
        id: 'app.allCategories',
        defaultMessage: 'All categories',
        description: 'All categories',
    },
    categorySearch: {
        id: 'app.categorySearch',
        defaultMessage: 'What are you looking for?',
        description: 'What are you looking for?'
    },
    searchCategory: {
        id: 'app.searchCategory',
        defaultMessage: 'Search your categories',
        description: 'Search your categories'
    },
    showLessText: {
        id: 'app.showLessText',
        defaultMessage: 'Show less',
        description: 'Show less',
    },
    showMoreText: {
        id: 'app.showMoreText',
        defaultMessage: 'Show more',
        description: 'Show more',
    },
    minHourLabel: {
        id: 'app.minHourLabel',
        defaultMessage: 'Min hr:',
        description: 'Min hr:'
    },
    hoursLabel: {
        id: 'app.hoursLabel',
        defaultMessage: 'hr(s)',
        description: 'hr(s)'
    },
    maxQuantityLabel: {
        id: 'app.maxQuantityLabel',
        defaultMessage: 'Max Qty:',
        description: 'Max Qty:'
    },
    quantityText: {
        id: 'app.quantityText',
        defaultMessage: 'Qty',
        description: 'Qty'
    },
    clearAll: {
        id: 'app.clearAll',
        defaultMessage: 'Clear all',
        description: 'Clear all',
    },
    reviewYourRequest: {
        id: 'app.reviewYourRequest',
        defaultMessage: 'Review your request',
        description: 'Review your request',
    },
    creditOrDebit: {
        id: 'app.creditOrDebit',
        defaultMessage: 'Credit or Debit card',
        description: 'Credit or Debit card'
    },
    creditOrDebitNumber: {
        id: 'app.creditOrDebitNumber',
        defaultMessage: 'Credit/Debit number',
        description: 'Credit/Debit number'
    },
    addCard: {
        id: 'app.addCard',
        defaultMessage: 'Add card',
        description: 'Add card'
    },
    addWallet: {
        id: 'app.addWallet',
        defaultMessage: 'Add money to wallet',
        description: 'Add money to wallet'
    },
    walletText: {
        id: 'app.walletText',
        defaultMessage: 'Wallet:',
        description: 'Wallet:'
    },
    cardExpires: {
        id: 'app.cardExpires',
        defaultMessage: 'Expiry date',
        description: 'Expiry date',
    },
    cvv: {
        id: 'app.cvv',
        defaultMessage: 'CVV',
        description: 'cvv',
    },
    walletAmountText: {
        id: 'app.walletAmountText',
        defaultMessage: 'Enter amount',
        description: 'Enter amount',
    },
    stripeSecretKey: {
        id: 'app.stripeSecretKey',
        defaultMessage: 'Stripe secret key',
        description: 'Stripe settings'
    },
    stripeSecretKeyTooltip: {
        id: 'app.stripeSecretKeyTooltip',
        defaultMessage: 'Enter your Stripe secret key here. This key securely connects your application to the Stripe payment gateway. Ensure you use a test key for development and a live key for production.',
        description: 'Stripe settings'
    },
    walletAmountRequired: {
        id: 'app.walletAmountRequired',
        defaultMessage: 'Enter the amount',
        description: 'Enter the amount',
    },
    invalidWalletAmount: {
        id: 'app.invalidWalletAmount',
        defaultMessage: 'Please enter valid amount',
        description: 'Please enter valid amount',
    },
    editProfile: {
        id: 'app.editProfile',
        defaultMessage: 'Edit profile',
        description: 'Edit profile',
    },
    saveLabel: {
        id: 'app.saveLabel',
        defaultMessage: 'Save',
        description: 'Save',
    },
    clearAllTitle: {
        id: 'app.clearAllTitle',
        defaultMessage: 'Removal acknowledgment of the request',
        description: 'Removal acknowledgment of the request',
    },
    clearCart: {
        id: 'app.clearCart',
        defaultMessage: 'Clear cart',
        description: 'Clear cart',
    },
    confirm: {
        id: 'app.confirm',
        defaultMessage: 'Confirm',
        description: 'Confirm'
    },
    clearAllTitle: {
        id: 'app.clearAllTitle',
        defaultMessage: 'Removal acknowledgment of the request',
        description: 'Removal acknowledgment of the request',
    },
    clearAllContent: {
        id: 'app.clearAllContent',
        defaultMessage: 'Are you sure want to clear all the selected categories?',
        description: 'Are you sure want to clear all the selected categories?',
    },
    payoutCurrency: {
        id: 'app.payoutCurrency',
        defaultMessage: 'Preferred payout currency',
        description: 'Preferred payout currency'
    },
    setPayoutCurrency: {
        id: 'app.setPayoutCurrency',
        defaultMessage: 'Set as a preferred currency',
        description: 'Set as a preferred currency'
    },
    paginationrecords: {
        id: 'app.paginationrecords',
        defaultMessage: 'Records',
        description: 'Pagination records'
    },
    roles: {
        id: 'app.roles',
        defaultMessage: 'Roles',
        description: 'Roles',
    },
    siteConfigStripePublicKeyTooltip: {
        id: 'app.siteConfigStripePublicKeyTooltip',
        defaultMessage: 'This field decides the mode of payment(Live payment or Test payment)',
        description: 'This field decides the mode of payment(Live payment or Test payment)',
    },
    siteConfigSmtpHostTooltip: {
        id: 'app.siteConfigSmtpHostTooltip',
        defaultMessage: 'This field refers to the Simple Mail Transfer Protocol (SMTP) server address.  An SMTP server is responsible for sending and receiving emails. The host address is the domain name or IP address of the server you\'ll be using to send emails.',
        description: 'This field refers to the Simple Mail Transfer Protocol (SMTP) server address.  An SMTP server is responsible for sending and receiving emails. The host address is the domain name or IP address of the server you\'ll be using to send emails.',
    },
    siteConfigSmtpPortTooltip: {
        id: 'app.siteConfigSmtpPortTooltip',
        defaultMessage: 'This field specifies the port number on the SMTP server that you\'ll connect to.',
        description: 'This field specifies the port number on the SMTP server that you\'ll connect to.',
    },
    siteConfigSmtpEmailTooltip: {
        id: 'app.siteConfigSmtpEmailTooltip',
        defaultMessage: 'This field likely represents the email address that will be used as the "from" address in the emails sent from your application. It\'s the address that recipients will see in their inbox.',
        description: 'This field likely represents the email address that will be used as the "from" address in the emails sent from your application. It\'s the address that recipients will see in their inbox.',
    },
    siteConfigSmtpSenderTooltip: {
        id: 'app.siteConfigSmtpSenderTooltip',
        defaultMessage: 'This field refers to the name that will appear in the "from" field of the emails.',
        description: 'This field refers to the name that will appear in the "from" field of the emails.',
    },
    siteConfigSmtpSenderEmailTooltip: {
        id: 'app.siteConfigSmtpSenderEmailTooltip',
        defaultMessage: 'This field refers to the email address that will be used to send email notifications.',
        description: 'This field refers to the email address that will be used to send email notifications.',
    },
    siteConfigSmtpPasswordTooltip: {
        id: 'app.siteConfigSmtpPasswordTooltip',
        defaultMessage: 'This field is for the password associated with the SMTP email address.',
        description: 'This field is for the password associated with the SMTP email address.',
    },
    siteConfigFcmPushTooltip: {
        id: 'app.siteConfigFcmPushTooltip',
        defaultMessage: 'It\'s nothing but a key which helps you to send push notifications.You can create a keys from your Firebase account',
        description: 'It\'s nothing but a key which helps you to send push notifications.You can create a keys from your Firebase account',
    },
    siteConfigMaximumImageTooltip: {
        id: 'app.siteConfigMaximumImageTooltip',
        defaultMessage: 'This field allows the admin to set the maximum upload size for images.',
        description: 'This field allows the admin to set the maximum upload size for images.',
    },
    appSettingMaximumSubCategoriesTooltip: {
        id: 'app.appSettingMaximumSubCategoriesTooltip',
        defaultMessage: 'This field allows the admin to Set the maximum number of sub-categories a user can choose when requesting a job',
        description: 'This field allows the admin to Set the maximum number of sub-categories a user can choose when requesting a job',
    },
    appSettingJobAcceptanceServiceProviderTooltip: {
        id: 'app.appSettingJobAcceptanceServiceProviderTooltip',
        defaultMessage: 'This setting determines the maximum amount of time a service provider has to accept a job request',
        description: 'This setting determines the maximum amount of time a service provider has to accept a job request',
    },
    appSettingMaximumDistanceTooltip: {
        id: 'app.appSettingMaximumDistanceTooltip',
        defaultMessage: 'This setting defines the maximum radius within which the app will search for available service providers. A larger radius may increase the pool of potential providers, but it may also take longer to find a suitable match.',
        description: 'This setting defines the maximum radius within which the app will search for available service providers. A larger radius may increase the pool of potential providers, but it may also take longer to find a suitable match.',
    },
    appSettingMaximumEmergencyTooltip: {
        id: 'app.appSettingMaximumEmergencyTooltip',
        defaultMessage: 'This setting specifies the maximum number of emergency contacts that a user can provide when requesting a service.',
        description: 'This setting specifies the maximum number of emergency contacts that a user can provide when requesting a service.',
    },
    appSettingScheduleIntervalTooltip: {
        id: 'app.appSettingScheduleIntervalTooltip',
        defaultMessage: 'This setting determines the default time interval between service appointments. You can adjust this interval to suit the specific needs of your cleaning service.',
        description: 'This setting determines the default time interval between service appointments. You can adjust this interval to suit the specific needs of your cleaning service.',
    },
    appSettingAdditionWorkTooltip: {
        id: 'app.appSettingAdditionWorkTooltip',
        defaultMessage: 'This setting specifies the maximum amount of time a service provider has, to accept an additional work request during a service appointment.',
        description: 'This setting specifies the maximum amount of time a service provider has, to accept an additional work request during a service appointment.',
    },
    appSettingPreferredServiceTooltip: {
        id: 'app.appSettingPreferredServiceTooltip',
        defaultMessage: 'This setting determines the number of preferred service providers that a user can select.',
        description: 'This setting determines the number of preferred service providers that a user can select.',
    },
    appSettingForceUpdateTooltip: {
        id: 'app.appSettingForceUpdateTooltip',
        defaultMessage: 'This field allows the admin to control/modify the application version status. When this feature is enabled, the users will receive a modal popup concerning the application update.',
        description: 'This field allows the admin to control/modify the application version status. When this feature is enabled, the users will receive a modal popup concerning the application update.',
    },
    appSettingAndroidVersionTooltip: {
        id: 'app.appSettingAndroidVersionTooltip',
        defaultMessage: 'This field allows the admin to enter the Android version of the User application',
        description: 'This field allows the admin to enter the Android version of the User application',
    },
    appSettingIosVersionTooltip: {
        id: 'app.appSettingIosVersionTooltip',
        defaultMessage: 'This field allows the admin to enter the iOS version of the User application',
        description: 'This field allows the admin to enter the iOS version of the User application',
    },
    appSettingServiceProviderAndroidVersionTooltip: {
        id: 'app.appSettingServiceProviderAndroidVersionTooltip',
        defaultMessage: 'This field allows the admin to enter the Andriod version of the Service provider application',
        description: 'This field allows the admin to enter the Andriod version of the Service provider application',
    },
    appSettingServiceProviderIosVersionTooltip: {
        id: 'app.appSettingServiceProviderIosVersionTooltip',
        defaultMessage: 'This field allows the admin to enter the iOS version of the Service provider application',
        description: 'This field allows the admin to enter the iOS version of the Service provider application',
    },
    appSettingSleepModeTooltip: {
        id: 'app.appSettingSleepModeTooltip',
        defaultMessage: 'It is used to choose whether the Service provider app should remain open on the mobile device until the user decides to close it.',
        description: 'It is used to choose whether the Service provider app should remain open on the mobile device until the user decides to close it.',
    },
    appSettingJobAcceptanceTimeTooltip: {
        id: 'app.appSettingJobAcceptanceTimeTooltip',
        defaultMessage: 'This setting determines whether the service provider will be shown the time a customer has allotted for them to accept a job. This can help them prioritize jobs based on urgency.',
        description: 'This setting determines whether the service provider will be shown the time a customer has allotted for them to accept a job. This can help them prioritize jobs based on urgency.',
    },
    appSettingJobListTooltip: {
        id: 'app.appSettingJobListTooltip',
        defaultMessage: 'This field allows the admin to show or hide the job list on the provider\'s job request window.',
        description: 'This field allows the admin to show or hide the job list on the provider\'s job request window.',
    },
    appSettingJobPhotoTooltip: {
        id: 'app.appSettingJobPhotoTooltip',
        defaultMessage: 'This setting determines whether the service provider will be shown any photos included with the job request. Photos can provide valuable context about the job and help the provider prepare accordingly.',
        description: 'This setting determines whether the service provider will be shown any photos included with the job request. Photos can provide valuable context about the job and help the provider prepare accordingly.',
    },
    appSettingJobDescriptionTooltip: {
        id: 'app.appSettingJobDescriptionTooltip',
        defaultMessage: 'This setting determines whether the service provider will be shown a detailed description of the job, including any specific requirements or instructions.',
        description: 'This setting determines whether the service provider will be shown a detailed description of the job, including any specific requirements or instructions.',
    },
    appSettingEstimatedPriceTooltip: {
        id: 'app.appSettingEstimatedPriceTooltip',
        defaultMessage: 'This field allows the admin to show or hide the estimated price on the provider\'s job request window.',
        description: 'This field allows the admin to show or hide the estimated price on the provider\'s job request window.',
    },
    appSettingJobLocationTooltip: {
        id: 'app.appSettingJobLocationTooltip',
        defaultMessage: 'This field allows the admin to show or hide the job location on the provider\'s job request window.',
        description: 'This field allows the admin to show or hide the job location on the provider\'s job request window.',
    },
    appSettingProviderAppNotificationTooltip: {
        id: 'app.appSettingProviderAppNotificationTooltip',
        defaultMessage: 'This setting allows the admin to enable or disable automatic app opening when a new job request notification is received. This can help ensure that service providers don\'t miss any opportunities.',
        description: 'This setting allows the admin to enable or disable automatic app opening when a new job request notification is received. This can help ensure that service providers don\'t miss any opportunities.',
    },
    appSettingRequestTimerToneTooltip: {
        id: 'app.appSettingRequestTimerToneTooltip',
        defaultMessage: 'This option allows the admin to manage whether the sound notification to be triggered while receiving the job request.',
        description: 'This option allows the admin to manage whether the sound notification to be triggered while receiving the job request.',
    },
    appSettingUploadTimerToneTooltip: {
        id: 'app.appSettingUploadTimerToneTooltip',
        defaultMessage: 'This field will help the admin to upload the job timer tone for the partner application',
        description: 'This field will help the admin to upload the job timer tone for the partner application',
    },
    appSettingSupportTooltip: {
        id: 'app.appSettingSupportTooltip',
        defaultMessage: 'This section provides contact information for the service provider support team, including a phone number, email address, and Skype.',
        description: 'This section provides contact information for the service provider support team, including a phone number, email address, and Skype.',
    },
    appSettingContactNoTooltip: {
        id: 'app.appSettingContactNoTooltip',
        defaultMessage: 'It indicates the platform contact phone number.',
        description: 'It indicates the platform contact phone number.',
    },
    appSettingContactEmailTooltip: {
        id: 'app.appSettingContactEmailTooltip',
        defaultMessage: 'It indicates the platform contact email',
        description: 'It indicates the platform contact email',
    },
    appSettingSkypeTooltip: {
        id: 'app.appSettingSkypeTooltip',
        defaultMessage: 'It indicates the platform skype ID',
        description: 'It indicates the platform skype ID',
    },
    manageFareLocationTooltip: {
        id: 'app.manageFareLocationTooltip',
        defaultMessage: 'This field allows the admin to specify the geographical area where this fare will be applicable. You can choose from specific locations, regions, or the entire world.',
        description: 'This field allows the admin to specify the geographical area where this fare will be applicable. You can choose from specific locations, regions, or the entire world.',
    },
    manageFareCategoryTooltip: {
        id: 'app.manageFareCategoryTooltip',
        defaultMessage: 'This field allows the admin to Select the main category of the service to which this fare belongs',
        description: 'This field allows the admin to Select the main category of the service to which this fare belongs',
    },
    manageFareSubCategoryTooltip: {
        id: 'app.manageFareSubCategoryTooltip',
        defaultMessage: 'This field allows the admin to Select a specific sub-category for this fare.',
        description: 'This field allows the admin to Select a specific sub-category for this fare.',
    },
    manageFareStatusTooltip: {
        id: 'app.manageFareStatusTooltip',
        defaultMessage: 'This field allows the admin to set the status of the fare. You can choose between "Active" and "Inactive." An active fare will be used for pricing calculations, while an inactive fare will not.',
        description: 'This field allows the admin to set the status of the fare. You can choose between "Active" and "Inactive." An active fare will be used for pricing calculations, while an inactive fare will not.',
    },
    manageFareCurrencyTooltip: {
        id: 'app.manageFareCurrencyTooltip',
        defaultMessage: 'This field allows the admin to Select the currency in which the fare is denominated.',
        description: 'This field allows the admin to Select the currency in which the fare is denominated.',
    },
    manageFareEditableServiceProviderTooltip: {
        id: 'app.manageFareEditableServiceProviderTooltip',
        defaultMessage: 'This field allows the admin to Determine if service providers can modify this fare',
        description: 'This field allows the admin to Determine if service providers can modify this fare',
    },
    manageFareBaseTooltip: {
        id: 'app.manageFareBaseTooltip',
        defaultMessage: 'This field allows the admin to set the base price for this fare.',
        description: 'This field allows the admin to set the base price for this fare.',
    },
    manageFareMaximumQuantityTooltip: {
        id: 'app.manageFareMaximumQuantityTooltip',
        defaultMessage: 'This field allows the admin to Set the maximum number of services that can be selected at this fare',
        description: 'This field allows the admin to Set the maximum number of services that can be selected at this fare',
    },
    googleMapLabel: {
        id: 'app.googleMapLabel',
        defaultMessage: 'Google Maps API keys',
        description: 'Mobile App Settings'
    },
    userAppAndroidMapApiKey: {
        id: 'app.userAppAndroidMapApiKey',
        defaultMessage: 'User app Android map API key',
        description: 'Mobile App Settings'
    },
    serviceProviderAppAndroidMapAPIKey: {
        id: 'app.serviceProviderAppAndroidMapAPIKey',
        defaultMessage: 'Service provider app Android map API Key',
        description: 'Mobile App Settings'
    },
    userAppAndroidTooltip: {
        id: 'app.userAppTooltip',
        defaultMessage: 'Enter your Map API key to enable map features for the user Android app. This key allows access to location-based services such as route planning, location tracking, and nearby searches for stores. Make sure the key is valid and authorized for the user app.',
        description: 'Mobile App Settings'
    },
    serviceProviderAndroidTooltip: {
        id: 'app.driverAppTooltip',
        defaultMessage: 'Enter your Map API key to enable map features for the service provider Android app. This key enables navigation, route optimization, and real-time location updates for service providers. Ensure the key is valid and authorized for use with the service provider app.',
        description: 'Mobile App Settings'
    },

    clearCartContent: {
        id: 'app.clearCartContent',
        defaultMessage: 'You have already added services in different category. Do you want to replace the services?',
        description: 'Clear cart content',
    },
    clear: {
        id: 'app.clear',
        defaultMessage: 'Clear',
        description: 'Clear',
    },
    goBackText: {
        id: 'app.goBackText',
        defaultMessage: 'Go back',
        description: 'Go back'
    },
    priceBreakdown: {
        id: 'app.priceBreakdown',
        defaultMessage: 'Price breakdown',
        description: 'Price breakdown'
    },
    couponDiscount: {
        id: 'app.couponDiscount',
        defaultMessage: 'Coupon discount',
        description: 'Coupon discount'
    },
    visitFeeToolTipContent: {
        id: 'app.visitFeeToolTipContent',
        defaultMessage: 'This is the fee that the user has to pay to the service provider for visiting their place.',
        description: 'This is the fee that the user has to pay to the service provider for visiting their place.'
    },
    serviceFeeToolTipContent: {
        id: 'app.serviceFeeToolTipContent',
        defaultMessage: 'Fee for using the platform.',
        description: 'Fee for using the platform.'
    },
    discountToolTipContent: {
        id: 'app.discountToolTipContent',
        defaultMessage: 'Discount applied for the code you used.',
        description: 'Discount applied for the code you used.'
    },
    myCart: {
        id: 'app.myCart',
        defaultMessage: 'My cart',
        description: 'My cart',
    },
    describeWorkText: {
        id: 'app.describeWorkText',
        defaultMessage: 'Type here',
        description: 'Type here'
    },
    describeWorkLabel: {
        id: 'app.describeWorkLabel',
        defaultMessage: 'Describe the work',
        description: 'Describe the work'
    },
    hourLabel: {
        id: 'app.hourLabel',
        defaultMessage: 'hr',
        description: 'hr'
    },
    uploadPhotosText: {
        id: 'app.uploadPhotosText',
        defaultMessage: 'Upload photos',
        description: 'Upload photos'
    },
    ofLabel: {
        id: 'app.ofLabel',
        defaultMessage: 'of',
        description: 'ofLabel'
    },
    googlePayText: {
        id: 'app.googlePayText',
        defaultMessage: 'Google Pay',
        description: 'GooglePay',
    },
    cardLabel: {
        id: 'app.cardLabel',
        defaultMessage: 'I agree to make payments using the debit/credit card added on',
        description: 'I agree to make payments using the debit/credit card added on'
    },
    promoCode: {
        id: 'app.promoCode',
        defaultMessage: 'Promo code',
        description: 'Promo code'
    },
    applied: {
        id: 'app.applied',
        defaultMessage: '(Applied)',
        description: '(Applied)'
    },
    promoCodeSearch: {
        id: 'app.promoCodeSearch',
        defaultMessage: 'Select or enter promo code',
        description: 'Select or enter promo code'
    },
    promoCodeOffers: {
        id: 'app.promoCodeOffers',
        defaultMessage: 'Related offers',
        description: 'Related offers'
    },
    codeLabel: {
        id: 'app.codeLabel',
        defaultMessage: 'Code:',
        description: 'Code:'
    },
    applyLabel: {
        id: 'app.applyLabel',
        defaultMessage: 'Apply',
        description: 'Apply'
    },
    promoCodeSearch: {
        id: 'app.promoCodeSearch',
        defaultMessage: 'Select or enter promo code',
        description: 'Select or enter promo code'
    },
    noPromoCode: {
        id: 'app.noPromoCode',
        defaultMessage: 'You haven\'t received any promo code',
        description: 'You haven\'t received any promo code'
    },
    confirmBooking: {
        id: 'app.confirmBooking',
        defaultMessage: 'Confirm booking',
        description: 'Confirm booking'
    },
    cancelReasonExceed: {
        id: 'app.cancelReasonExceed',
        defaultMessage: 'Limit exceeded! You can’t enter more than 10,000 characters',
        description: 'Limit exceeded! You can’t enter more than 10,000 characters'
    },
    bookingTitle: {
        id: 'app.bookingTitle',
        defaultMessage: 'When do you need?',
        description: 'When do you need?'
    },
    scheduleLater: {
        id: 'app.scheduleLater',
        defaultMessage: 'Schedule later',
        description: 'Schedule later'
    },
    goBackText: {
        id: 'app.goBackText',
        defaultMessage: 'Go back',
        description: 'Go back'
    },
    chooseLocation: {
        id: 'app.chooseLocation',
        defaultMessage: 'Choose your location',
        description: 'Choose your location'
    },
    yourLocationText: {
        id: 'app.yourLocationText',
        defaultMessage: 'Your location',
        description: 'Your Location'
    },
    locationLabel: {
        id: 'app.locationLabel',
        defaultMessage: 'Enter your location',
        description: 'Enter your Location'
    },
    noServiceProvider: {
        id: 'app.noServiceProvider',
        defaultMessage: 'No nearby service provider found',
        description: 'No nearby service provider found'
    },
    connectProviderText: {
        id: 'app.connectProviderText',
        defaultMessage: 'Connecting you to nearby providers',
        description: 'Connecting you to nearby providers'
    },
    manageCategory: {
        id: 'app.manageCategory',
        defaultMessage: 'Manage Category',
        description: 'Manage Category'
    },
    userAppIosMapApiKey: {
        id: 'app.userAppIosMapApiKey',
        defaultMessage: 'User app iOS map API key',
        description: 'Mobile App Settings'
    },
    serviceProviderIosMapAPIKey: {
        id: 'app.serviceProviderIosMapAPIKey',
        defaultMessage: 'Service provider app iOS map API key',
        description: 'Mobile App Settings'
    },
    userAppIosTooltip: {
        id: 'app.userAppIosTooltip',
        defaultMessage: 'Enter your Map API key to enable map features for the user iOS app. This key allows access to location-based services such as route planning, location tracking, and nearby searches for stores. Make sure the key is valid and authorized for the user app.',
        description: 'Mobile App Settings'
    },
    serviceProviderIosTooltip: {
        id: 'app.driverAppIosTooltip',
        defaultMessage: 'Enter your Map API key to enable map features for the service provider iOS app. This key enables navigation, route optimization, and real-time location updates for service providers. Ensure the key is valid and authorized for use with the service provider app.',
        description: 'Mobile App Settings'
    },
    locationWarning: {
        id: 'app.locationWarning',
        defaultMessage: 'We don\'t recognize that location',
        description: 'We don\'t recognize that location',
    },

    editManageServices: {
        id: 'app.editManageServices',
        defaultMessage: 'Edit Manage Services',
        description: 'Edit Manage Services',
    },
    manageSubCategoryMenu: {
        id: 'app.manageSubCategoryMenu',
        defaultMessage: 'Manage Service Provider Sub Categories',
        description: 'Manage Service Provider Sub Categories',
    },
    saveButton: {
        id: 'app.saveButton',
        defaultMessage: 'Save',
        description: 'Save',
    },
    baseFare: {
        id: 'app.baseFare',
        defaultMessage: 'Base fare:',
        description: 'Base fare:'
    },
    maxQuantityLabel: {
        id: 'app.maxQuantityLabel',
        defaultMessage: 'Max Qty:',
        description: 'Max Qty:'
    },
    minHourLabel: {
        id: 'app.minHourLabel',
        defaultMessage: 'Min hr:',
        description: 'Min hr:'
    },
    manageServices: {
        id: 'app.manageServices',
        defaultMessage: 'Manage Services',
        description: 'Manage Services'
    },
    services: {
        id: 'app.services',
        defaultMessage: 'services',
        description: 'services'
    },
    baseFareTitle: {
        id: 'app.baseFareTitle',
        defaultMessage: 'Enter your service fare for',
        description: 'Enter your service fare for'
    },
    baseFareLabel: {
        id: 'app.baseFareLabel',
        defaultMessage: 'Base fare',
        description: 'Base fare'
    },
    baseFareToolTipContent: {
        id: 'app.baseFareToolTipContent',
        defaultMessage: 'The fare added will be considered as the Base fare for this Sub-category.',
        description: 'The fare added will be considered as the Base fare for this Sub-category.'
    },
    perHourLabel: {
        id: 'app.perHour',
        defaultMessage: '/hr',
        description: '/hr'
    },
    quantitlyLabel: {
        id: 'app.quantityLabel',
        defaultMessage: 'Quantity',
        description: 'Quantity'
    },
    serviceLabel: {
        id: 'app.serviceLabel',
        defaultMessage: 'Services',
        description: 'Services'
    },
    maximumCharcterLeft: {
        id: 'app.maximumCharcterLeft',
        defaultMessage: 'characters left.',
        description: 'maximumCharcterLeft',
    },
    mobileNumberRequired: {
        id: 'app.mobileNumberRequired',
        defaultMessage: 'Please enter a mobile number',
        description: 'Please enter a mobile number',
    },
    phoneNumberVerificationInfo1: {
        id: 'app.phoneNumberVerificationInfo1',
        defaultMessage: 'I agree to receive a message from',
        description: 'phoneNumberVerificationInfo1',
    },
    phoneNumberVerificationInfo2: {
        id: 'app.phoneNumberVerificationInfo2',
        defaultMessage: 'at the phone number provided above. I understand I will receive messages for the verification purposes. Click here to',
        description: 'PhoneNumberVerificationInfo',
    },
    phoneNumberVerificationInfo3: {
        id: 'app.phoneNumberVerificationInfo3',
        defaultMessage: 'know more.',
        description: 'PhoneNumberVerificationInfo',
    },

    configurationsSideMenu: {
        id: 'app.configurationsSideMenu',
        defaultMessage: 'Configurations',
        description: 'Side menu',
    },

    adminConfiguration: {
        id: 'app.adminConfiguration',
        defaultMessage: 'Admin Configuration',
        description: 'Side menu',
    },

    usersSidemenu: {
        id: 'app.usersSidemenu',
        defaultMessage: 'Users',
        description: 'Side menu',
    },

    opConfigurationSideMenu: {
        id: 'app.opConfigurationSideMenu',
        defaultMessage: 'Operation Configuration',
        description: 'Side menu',
    },

    jobSideMenu: {
        id: 'app.jobSideMenu',
        defaultMessage: 'Jobs',
        description: 'Side menu',
    },

    payoutSidemenu: {
        id: 'app.payoutSidemenu',
        defaultMessage: 'Provider Payouts',
        description: 'Side menu',
    },


    monitorSidemenu: {
        id: 'app.monitorSidemenu',
        defaultMessage: 'Monitor',
        description: 'Side menu',
    },

    announcementSideMenu: {
        id: 'app.announcementSideMenu',
        defaultMessage: 'Announcement',
        description: 'Side menu',
    },

    contentPageSideMenu: {
        id: 'app.contentPageSideMenu',
        defaultMessage: 'Content Pages',
        description: 'Side menu',
    },
    createNewBooking: {
        id: 'app.createNewBooking',
        defaultMessage: 'Create a new booking',
        description: 'Create a new booking',
    },
    currentBookings: {
        id: 'app.currentBookings',
        defaultMessage: 'Current bookings',
        description: 'Current bookings',
    },
    noBookings: {
        id: 'app.noBookings',
        defaultMessage: 'You haven\'t booked any services yet',
        description: 'You haven\'t booked any services yet'
    },
    currentBookingsText: {
        id: 'app.currentBookingsText',
        defaultMessage: 'Current',
        description: 'Current',
    },
    pastBookingsText: {
        id: 'app.pastBookingsText',
        defaultMessage: 'Past',
        description: 'Past',
    },
    maximumCharacterLeft: {
        id: 'app.maximumCharacterLeft',
        defaultMessage: 'characters left.',
        description: 'maximumCharacterLeft',
    },
    requestCreatedContent: {
        id: 'app.requestCreatedContent',
        defaultMessage: 'Your job request has been created successfully',
        description: 'Your job request has been created successfully'
    },
    requestAcceptedContent: {
        id: 'app.requestAcceptedContent',
        defaultMessage: 'accepted your request and will reach your location shortly',
        description: 'accepted your request and will reach your location shortly'
    },
    requestArrivedContent: {
        id: 'app.requestArrivedContent',
        defaultMessage: 'has reached your location for providing you with an extraordinary service',
        description: 'has reached your location for providing you with an extraordinary service'
    },
    requestReviewedContent: {
        id: 'app.requestReviewedContent',
        defaultMessage: 'has visited the site and reviewed the service request',
        description: 'has visited the site and reviewed the service request'
    },
    requestStartedContent: {
        id: 'app.requestStartedContent',
        defaultMessage: 'is started working on your service request',
        description: 'is started working on your service request'
    },
    requestCompletedContent: {
        id: 'app.requestCompletedContent',
        defaultMessage: 'Your service has been completed by',
        description: 'Your service has been completed by'
    },
    orderStatusLabel: {
        id: 'app.orderStatusLabel',
        defaultMessage: 'Order status',
        description: 'Order status'
    },
    viewTimeLine: {
        id: 'app.viewTimeLine',
        defaultMessage: '(View Timeline)',
        description: '(View Timeline)'
    },
    serviceStarted: {
        id: 'app.serviceStarted',
        defaultMessage: 'Service started',
        description: 'Service started'
    },
    cancelReasonSubText: {
        id: 'app.cancelReasonSubText',
        defaultMessage: 'We would like to hear your feedback! We\'d appreciate it if you would take a moment to let us know why you are cancelling.',
        description: 'We would like to hear your feedback! We\'d appreciate it if you would take a moment to let us know why you are cancelling.',
    },
    other: {
        id: 'app.other',
        defaultMessage: 'Other',
        description: 'Other',
    },
    cancelReasonLabel: {
        id: 'app.cancelReasonLabel',
        defaultMessage: 'Enter your cancel reason',
        description: 'Enter your cancel reason'
    },
    idText: {
        id: 'app.idText',
        defaultMessage: 'ID:',
        description: 'ID:'
    },
    trackJob: {
        id: 'app.trackJob',
        defaultMessage: 'Track job',
        description: 'Track job'
    },
    printBooking: {
        id: 'app.printBooking',
        defaultMessage: 'Print booking',
        description: 'Print booking'
    },
    dateAndTime: {
        id: 'app.dateAndTime',
        defaultMessage: 'Date & Time',
        description: 'Date & Time'
    },
    photos: {
        id: 'app.photos',
        defaultMessage: 'Photos',
        description: 'Photos'
    },
    toolTipForBookings: {
        id: 'app.toolTipForBookings',
        defaultMessage: 'This is an estimated fare. It might vary.',
        description: 'This is an estimated fare. It might vary.',
    },
    viewDetails: {
        id: 'app.viewDetails',
        defaultMessage: 'View details',
        description: 'View details'
    },
    proceedToPay: {
        id: 'app.proceedToPay',
        defaultMessage: 'Proceed to pay',
        description: 'Proceed to pay'
    },
    SupportedPayments: {
        id: 'app.SupportedPayments',
        defaultMessage: 'Supported payments',
        description: 'Supported payments',
    },
    billingDetails: {
        id: 'app.billingDetails',
        defaultMessage: 'Billing details',
        description: 'Billing details'
    },
    tipsAdded: {
        id: 'app.tipsAdded',
        defaultMessage: 'Tips added',
        description: 'tipsAdded'
    },
    tips: {
        id: 'app.tips',
        defaultMessage: 'Tips',
        description: 'tips'
    },
    yourTripAmount: {
        id: 'app.yourTipsAmount',
        defaultMessage: '*Your service was',
        description: 'yourTipsAmount'
    },
    addTips: {
        id: 'app.addTips',
        defaultMessage: 'Add a tip for',
        description: 'addTips'
    },
    topFeaturesText: {
        id: 'app.topFeaturesText',
        defaultMessage: 'Top features',
        description: 'Top features'

    },
    viewAll: {
        id: 'app.viewAll',
        defaultMessage: 'View all',
        description: 'View all',
    },
    xURL: {
        id: 'app.xURL',
        defaultMessage: 'X URL',
        description: 'X URL',
    },
    facebookURL: {
        id: 'app.facebookURL',
        defaultMessage: 'Facebook URL',
        description: 'Facebook URL',
    },
    instagramURL: {
        id: 'app.instagramURL',
        defaultMessage: 'Instagram URL',
        description: 'Instagram URL',
    },
    youtubeURL: {
        id: 'app.youtubeURL',
        defaultMessage: 'Youtube URL',
        description: 'Youtube URL',
    },
    paymentCompleted: {
        id: 'app.paymentCompleted',
        defaultMessage: 'Payment completed',
        description: 'Payment completed'
    },
    rateYourExperience: {
        id: 'app.rateYourExperience',
        defaultMessage: '(Rate your experience)',
        description: '(Rate your experience)'
    },
    scheduleYourBooking: {
        id: 'app.scheduleYourBooking',
        defaultMessage: 'Schedule your booking',
        description: 'Schedule your booking'
    },
    bookingScheduleOn: {
        id: 'app.bookingScheduleOn',
        defaultMessage: '*Booking scheduled on',
        description: 'Booking scheduled'
    },
    scheduledOn: {
        id: 'app.scheduledOn',
        defaultMessage: 'Scheduled on:',
        description: 'Scheduled on:'
    },
    editDateAndTime: {
        id: 'app.editDateAndTime',
        defaultMessage: 'Edit date & time',
        description: 'Edit date & time'
    },
    cancelSchedule: {
        id: 'app.cancelSchedule',
        defaultMessage: 'Are you sure want to cancel your scheduled job?',
        description: 'Are you sure want to cancel your scheduled job?',
    },
    updateSchedule: {
        id: 'app.updateSchedule',
        defaultMessage: 'Update your schedule',
        description: 'updateSchedule'
    },
    paidText: {
        id: 'app.paidText',
        defaultMessage: 'Paid via',
        description: 'Paid via'
    },
    termsOfService: {
        id: 'app.termsOfService',
        defaultMessage: 'Terms of Service',
        description: 'termsOfService'
    },
    additionalWorkRequest: {
        id: 'app.additionalWorkRequest',
        defaultMessage: 'Additional work request',
        description: 'additionalWorkRequest'
    },
    jobTitle: {
        id: 'app.jobTitle',
        defaultMessage: 'Job:',
        description: 'jobTitle'
    },
    estimatedAdditionalCost: {
        id: 'app.estimatedAdditionalCost',
        defaultMessage: 'Estimated additional cost',
        description: 'estimatedAdditionalCost'
    },
    workDetails: {
        id: 'app.workDetails',
        defaultMessage: 'Work details',
        description: 'workDetails'
    },
    requestBy: {
        id: 'app.requestBy',
        defaultMessage: "Requested by",
        description: 'requestBy'
    },
    accept: {
        id: 'app.accept',
        defaultMessage: 'Accept',
        description: 'accept'
    },
    reject: {
        id: 'app.reject',
        defaultMessage: 'Reject',
        description: 'reject'
    },
    viewText: {
        id: 'app.viewText',
        defaultMessage: '(view)',
        description: 'viewText'
    },
    additionalPayment: {
        id: 'app.additionalPayment',
        defaultMessage: 'Additional payment',
        description: 'additionalPayment'
    },
    messageLabel: {
        id: 'app.messageLabel',
        defaultMessage: 'Type something...',
        description: 'Type something...'
    },
    accountIDToolTip: {
        id: 'app.accountIDToolTip',
        defaultMessage: 'It’s a unique identifier for your Twilio account',
        description: 'It’s a unique identifier for your Twilio account',
    },
    authtokenToolTip: {
        id: 'app.authtokenToolTip',
        defaultMessage: 'It’s a type of secret key for your account. It helps identify whether the account is authorized or not.',
        description: 'It’s a type of secret key for your account. It helps identify whether the account is authorized or not.',
    },
    senderToolTip: {
        id: 'app.senderToolTip',
        defaultMessage: 'The name or number that will appear as the sender in the SMS messages received by users',
        description: 'The name or number that will appear as the sender in the SMS messages received by users',
    },
    apiKeyToolTip: {
        id: 'app.apiKeyToolTip',
        defaultMessage: 'This key is used to authenticate your application with the SMS provider’s API.',
        description: 'This key is used to authenticate your application with the SMS provider’s API.',
    },
    secretKeyToolTip: {
        id: 'app.secretKeyToolTip',
        defaultMessage: 'A private key used for secure authentication. It helps verify that the request is coming from an authorized source.',
        description: 'A private key used for secure authentication. It helps verify that the request is coming from an authorized source.',
    },
    logoutLabel: {
        id: 'app.logoutLabel',
        defaultMessage: 'Are you sure you want to log out?',
        description: 'Are you sure you want to log out?'
    },
    payPalSettings: {
        id: 'app.payPalSettings',
        defaultMessage: 'PayPal settings',
        description: 'PayPal Settings'
    },
    payPalClientId: {
        id: 'app.paypalClientId',
        defaultMessage: 'PayPal client id',
        description: 'PayPal client id',
    },
    payPalSecretKey: {
        id: 'app.paypalSecretKey',
        defaultMessage: 'PayPal secret key',
        description: 'PayPal secret key',
    },
    payPalHost: {
        id: 'app.paypalHost',
        defaultMessage: 'PayPal host',
        description: 'PayPal Host',
    },
    allowedPaymentCurrency: {
        id: 'app.allowedPaymentCurrency',
        defaultMessage: 'Allowed Payment Currency',
        description: 'currencyManagement value',
    },
    addLabel: {
        id: 'app.addLabel',
        defaultMessage: 'Add',
        description: 'Add',
    },
    paypalLabel: {
        id: 'app.paypalLabel',
        defaultMessage: 'PayPal',
        description: 'Paypal'
    },
    chooseCurrency: {
        id: 'app.chooseCurrency',
        defaultMessage: 'Choose currency',
        description: 'Choose currency',
    },
    stripeLabel: {
        id: 'app.stripe',
        defaultMessage: 'Stripe',
        description: 'Stripe'
    },
    walletLabel: {
        id: 'app.walletLabel',
        defaultMessage: 'In wallet:',
        description: 'In wallet:'
    },
    googleMapLabelForWeb: {
        id: 'app.googleMapLabelForWeb',
        defaultMessage: 'Web app – Google Maps API key',
        description: 'Web app – Google Maps API key'
    },
    googleMapBrowserKeyLabel: {
        id: 'app.googleMapBrowserKeyLabel',
        defaultMessage: 'Google Maps browser API key',
        description: 'Google Maps browser API key',
    },
    googleMapServerKeyLabel: {
        id: 'app.googleMapServerKeyLabel',
        defaultMessage: 'Google Maps server API key',
        description: 'Google Maps server API key',
    },
    googleMapBrowserKeyToolTip: {
        id: 'app.googleMapBrowserKeyToolTip',
        defaultMessage: "Enter your Google Maps JavaScript API Key.This key is used for client-side operations, such as displaying maps, autocomplete suggestions, and place details directly in your users' web browsers",
        description: 'Google Map Browser key ToolTip',
    },
    googleMapServerKeyToolTip: {
        id: 'app.googleMapServerKeyToolTip',
        defaultMessage: "Enter your Google Maps Web Services API Key. This key is used for server-side operations, such as geocoding addresses, calculating distances, or accessing directions using Google Maps Platform web services. Keep this key strictly confidential and ensure you restrict it by IP address (your server's IP) for security.",
        description: 'Google Map Server key ToolTip',
    },
    whatsAppLabel: {
        id: 'app.whatsAppLabel',
        defaultMessage: 'WhatsApp',
        description: 'WhatsApp'
    },
    whatsAppPlaceholderLabel: {
        id: 'app.whatsAppPlaceholderLabel',
        defaultMessage: 'Enter your WhatsApp number',
        description: 'WhatsApp Placeholder'
    },
    appSettingsWhatsAppToolTip: {
        id: 'app.appSettingsWhatsAppToolTip',
        defaultMessage: 'It indicates the platform WhatsApp number, and it would help the users to contact you when it comes to an emergency Situation.',
        description: 'WhatsApp ToolTip'
    },
    setAsActive: {
        id: 'app.setAsActive',
        defaultMessage: 'Set as active',
        description: 'Set as active'
    },
    homeDescription: {
        id: 'app.homeDescription',
        defaultMessage: 'Banner description',
        description: 'Banner Description'
    },
    yourTipsAmountWas: {
        id: 'app.yourTipsAmountWas',
        defaultMessage: '*Your trip was',
        description: '*Your trip was'
    },
    walletTextLabel: {
        id: 'app.walletTextLabel',
        defaultMessage: 'Wallet',
        description: 'Wallet'
    },
    creditDebitLabel: {
        id: 'app.creditDebitLabel',
        defaultMessage: 'Credit/Debit card',
        description: 'Credit or Debit card'
    },
    selectProviderTitle: {
        id: 'app.selectProviderTitle',
        defaultMessage: 'Choose your selection process',
        description: 'Choose your selection process'
    },
    preferredProviderLabel: {
        id: 'app.preferredProviderLabel',
        defaultMessage: 'Preferred provider selection',
        description: 'Preferred provider selection'
    },
    radomProviderLabel: {
        id: 'app.radomProviderLabel',
        defaultMessage: 'Random provider selection',
        description: 'Random provider selection'
    },
    preferredProviderSectionContent: {
        id: 'app.preferredProviderSectionContent',
        defaultMessage: 'Choose the preferred service provider from the nearby available service providers list for your service request. Our system will connect with the chosen service provider for your need.',
        description: 'Choose the preferred service provider from the nearby available service providers list for your service request. Our system will connect with the chosen service provider for your need.'
    },
    radomProviderSectionContent: {
        id: 'app.radomProviderSectionContent',
        defaultMessage: 'Our system will auto connect the nearby available service provider that best fits for your need.',
        description: 'Our system will auto connect the nearby available service provider that best fits for your need.'
    },
    preferredProviderTitle: {
        id: 'app.preferredProviderTitle',
        defaultMessage: 'Choose your provider',
        description: 'Choose your provider'
    },
    connectPreferredProviderText: {
        id: 'app.connectPreferredProviderText',
        defaultMessage: 'Connecting to your preferred service provider ',
        description: 'Connecting to your preferred service provider '
    },
    currencyNoProvidersAvailable: {
        id: 'app.currencyNoProvidersAvailable',
        defaultMessage: 'Currently no service provider available!',
        description: 'Currently no service provider available!'
    },
    preferredProviderDeclineLabel: {
        id: 'app.preferredProviderDeclineLabel',
        defaultMessage: 'Your service request has been canceled by your preferred service provider.',
        description: 'Your service request has been canceled by your preferred service provider.'
    },
    requestDeclinedLabel: {
        id: 'app.requestDeclinedLabel',
        defaultMessage: 'Request declined',
        description: 'Request declined'
    }

});

export default messages;